import { NewHeader, PageHeader, dtFormatter, globalinchtopointfactor, globalnormalopacity } from "./AuxiliaryFunctions";
import { Container, Row, Col, FormLabel, FormControl, Button, Tooltip, OverlayTrigger, Table, Alert} from "react-bootstrap";
import Toast from 'react-bootstrap/Toast';
import { Stage, Layer, Group, Rect, Text, Line, Arrow } from 'react-konva';
import { useEffect, useState, useRef } from "react";
import MessageBox from './MessageBox';
import { FaArrowCircleLeft } from "react-icons/fa";
import { FaArrowCircleRight } from "react-icons/fa";
import { IoSave } from "react-icons/io5";
import { MdAddToPhotos, MdDelete, MdPropane } from "react-icons/md";
import { RectanglesVisualizer } from "./ComputeBoundingBox";
import DetailKitchenCabinets from "./ListOfKitchenCabinets";
import {AllCabinetConfigs} from "./BaseCabinets";
import KitchenQuoteJobInterview from "./KitchenQuoteJobInterview";
import InsertOrEditCurrentWall from "./InsertOrEditCurrentWall";
import { globalwallx, globalwally, coverHeight } from "./AuxiliaryFunctions";
import jsPDF from "jspdf";
import { autoTable } from 'jspdf-autotable';
import logo192 from './logo192.png';
import { useSelector } from 'react-redux';
import { checkCollision } from "./AuxiliaryFunctions";
import TopAndSideBar from "./TopAndSideBar";
import kitchenfastquoteService from "./services/kitchenfastquote.service";
import { useLocation, useParams } from 'react-router-dom';
import KitchenFastQuoteSpecialNotes from "./KitchenFastQuoteSpecialNotes";
import FastQuotingCabinetDataService from './services/fastquotingcabinet.service';
import FastQuotingCabinetVersionsDataService from './services/fastquotingcabinetversions.service';
import JobInterviewDataService from './services/job.service'
import ItemDataService from './services/item.service'
import Guidelines from './Guidelines';
import ModalVerifyEmail from './ModalVerifyEmail';
import Auth from "./services/auth.service.js";
import { IoWarning } from "react-icons/io5";
import { set } from "react-hook-form";

const wallx = globalwallx;
const wally = globalwally;
const coverheight = coverHeight;
var inchtopointfactor = globalinchtopointfactor;
const normalopacity = globalnormalopacity;
const wallColor = 'lightgray ';
const sidewallColor = 'Silver ';
const cabinetColor = 'Gray';
const collisionColor = '#FFC7CE';
const extracanvasx = 80;
const extracanvasy = 80;
const sidewallWidth = 25;

const inchtopoint = (inch) => {
  return inch*inchtopointfactor;
}

const ProgressModal = ({ visible }) => {
  if (!visible) return null;
  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <img src="logo192.png"/>
        <p>We are rendering your design. It will be ready in a few seconds... Please wait.</p>
        <span className="spinner-border spinner-border-sm"></span>
      </div>
    </div>
  );
};

// Basic inline styles for demo purposes
const styles = {
  container: {
    padding: '2rem',
    textAlign: 'center',
  },
  overlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
  },
};

function addWaterMark(doc) {
  var totalPages = doc.internal.getNumberOfPages();

  for (var i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    //doc.addImage(imgData, 'PNG', 40, 40, 75, 75);
    doc.setTextColor(150);
    doc.text(50, doc.internal.pageSize.height - 30, 'This layout was created using Cabinets Quick\'s online configurator.');
    doc.text(50, doc.internal.pageSize.height - 20, 'https://fe-dev.quickquotescabinets.com');
  }

  return doc;
}


const NewKitchenFastQuote = (props) => {

  const [tooltip, setTooltip] = useState({
    visible: false,
    text: "",
    x: 0,
    y: 0,
  });

  const handleMouseEnter = (e, shape) => {
    const stage = e.target.getStage();
    const pointerPos = stage.getPointerPosition();

    setTooltip({
      visible: true,
      text: `${shape.cabinetConfig}\nW=${Math.round(100*shape.width/inchtopointfactor)/100}, H=${Math.round(100*shape.height/inchtopointfactor)/100}, D=${24}`,
      x: pointerPos.x + 10,
      y: pointerPos.y + 10,
    });
  };

  const handleMouseMove = (e) => {
    if (!tooltip.visible) return;
    const stage = e.target.getStage();
    const pointerPos = stage.getPointerPosition();

    setTooltip((t) => ({
      ...t,
      x: pointerPos.x + 10,
      y: pointerPos.y + 10,
    }));
  };  

  const handleMouseLeave = () => {
    setTooltip({ visible: false, text: "", x: 0, y: 0 });
  };  

  const location = useLocation();
  const params = useParams();
  const kitchenfastquotemode = location?1:(props.mode === 0)?props.mode:1;
  const stageRef = useRef(null);
  const { user: currentUser } = useSelector((state) => state.auth);	

  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }  

  const showWidthStdDimensions = () => {
    console.log(cabinetConfig);
    let widthErrMessage = "Error in the width of the cabinet.";
    if (cabinetConfig.widthMin && cabinetConfig.widthMax) {
      if (parseFloat(cabinetConfig.widthMin) === parseFloat(cabinetConfig.widthMax)) {
        widthErrMessage = cabinetwidth + " in is not a standard width for " + cabinetConfig.configid + ". Standard width is " + cabinetConfig.widthMin + " in.";
      }
      else {
        widthErrMessage = cabinetwidth + " in is not a standard width for " + cabinetConfig.configid + ". Standard widths are between " + cabinetConfig.widthMin + " in and " + cabinetConfig.widthMax + " in.";
      }      
    }    
    setErrmessage(widthErrMessage);
    setShowerror(true);    
  }  

  const showHeightStdDimensions = () => {
    let heightErrMessage = "Error in the height of the cabinet.";
    if (cabinetConfig.allowedHeights) {
      if (cabinetConfig.allowedHeights.length === 1) {
        heightErrMessage = cabinetHeight + " in is not a standard height for " + cabinetConfig.configid + ". Standard height is " + cabinetConfig.allowedHeights[0] + " in.";
      }
      else {
        heightErrMessage = cabinetHeight + " in is not a standard height for " + cabinetConfig.configid + ". Standard heights are: \n" + cabinetConfig.allowedHeights.join(" in, ") + " in";
      }      
    }
    setErrmessage(heightErrMessage);
    setShowerror(true);    
  }

  const handleLayerDoubleClick = (e) => {
    onInsertCabinet({cabinetConfig, cabinettype, cabinetwidth, cabinetHeight});
  };    

  const sendVerifyEmail = (emailAddress) => {
    console.log("Sending verify email to user...");
    //console.log(currentUser);
    //Auth.verifyEmail(currentUser.email).then(() => {
    Auth.verifyEmail(emailAddress).then(() => {
      alert("A verification email has been sent to your email address. Please check your inbox and your spam folder.");
    })
    .catch((err) => {  
      console.log(err);
      alert(err.response?err.response.data.message:"Failed to send verification email. Please try again later.");
    });

  }	  

  const handleExportToPdf = async () => {
    const imageData = logo192;
    let pdf = new jsPDF('landscape', 'pt', 'a4'); // Create a new PDF document

    const pdfWidth = 1*pdf.internal.pageSize.getWidth()-20;
    const pdfHeight = 1*pdf.internal.pageSize.getHeight()-130;

    console.log("pdfWidth: " + pdfWidth); 
    console.log("pdfHeight: " + pdfHeight);

    for (var i=1;i<=walls.length;i++) { 
      if (stageRef.current) {

        pdf.addImage(imageData, 'PNG', 20, 40, 40, 50); // Add logo        
        pdf.setFontSize(12);
        pdf.text('KITCHEN ELEVATIONS LAYOUT FOR THE PROJECT', 100, 30);
        pdf.text('JOB: ' + jobname, 100, 45);
        pdf.text('JOB ADDRESS: ' + jobaddress, 100, 60);
        pdf.text('DATE PRINTED: ' + dtFormatter(new Date(),2), 100, 75);
        pdf.text('PRINTED BY: ' + currentUser.username, 100, 90);
        pdf.setFontSize(10);
        pdf.text('Wall Name: ' + walls[currentWallIndex].wallname + " (position from Left to Right: " + i + ")", 20, 120);

        await delay(3000);

        let stageRefWidth = stageRef.current.width(); 
        let stageRefHeight = stageRef.current.height();

        console.log("stageRefWidth: " + stageRefWidth);
        console.log("stageRefHeight: " + stageRefHeight);
        
        const imageRatio = stageRefWidth / stageRefHeight;
        const pageRatio = pdfWidth / pdfHeight;        

        let imgWidth, imgHeight;

        // Determine which dimension to scale by
        if (imageRatio > pageRatio) {
            // Image is wider than the page ratio: scale by width
            imgWidth = pdfWidth;
            imgHeight = pdfWidth / imageRatio;
        } else {
            // Image is taller than the page ratio: scale by height
            imgHeight = pdfHeight;
            imgWidth = pdfHeight * imageRatio;
        }        

        /*
        let imgWidth = stageRefWidth>stageRefHeight?pdfWidth:stageRefWidth*pdfHeight/stageRefHeight;
        let imgHeight = stageRefHeight*imgWidth/stageRefWidth; //stageRefWidth<=stageRefHeight?pdfHeight:stageRefHeight*imgWidth/stageRefWidth;

        console.log("imgWidth: " + imgWidth);
        console.log("imgHeight: " + imgHeight);

        console.log(pdfWidth/pdfHeight);
        console.log(stageRefWidth/stageRefHeight);
        */

        pdf.addImage(stageRef.current.toDataURL({
          mimeType: 'image/png',
          pixelRatio: 2, // Export at a higher resolution for better PDF quality
        }), 'PNG', 20, 130, imgWidth, imgHeight); // Add the image             

        pdf.addPage();         
        if (i<walls.length) {
          await delay(3000) 
          .then(async () => {
            onMoveToRightWall(); 
          })   
        } 
       
      }       
    }

    const headerarray = ["Item", "Qty", "Size (WxHxD)", "Cab Name","Wall Name"];
    var rectsForBaseWidth = []; 
    const basecabslistforwidth = walls.map((wall, index) => { 
      let filteredRects = wall.rectangles.filter(rect => 
        !rect.cabinetConfig.includes("Adjacen") && !rect.cabinetConfig.includes("Filler") && !rect.cabinetConfig.includes("placeholder") && rect.cabinettype !== "appliances"
      );
      filteredRects.forEach(rect => {    
        rectsForBaseWidth.push(rect);
      });
    });

    console.log(rectsForBaseWidth);

    var totalBaseWidth = 0;

    for (var i = 0; i < rectsForBaseWidth.length; i++) {
      if (rectsForBaseWidth[i].shapename === "left_corner" || rectsForBaseWidth[i].shapename === "right_corner") {
        totalBaseWidth += 2*((rectsForBaseWidth[i].width || 0 ) - 24*inchtopointfactor); // 24 in is the standard depth of a corner base cabinet
      }
      else {
        totalBaseWidth += (rectsForBaseWidth[i].width || 0 );
      }
      console.log(totalBaseWidth);
    }

    totalBaseWidth = totalBaseWidth/inchtopointfactor;
    console.log("total base width: " + totalBaseWidth);

    const cabslist = walls.map((wall, index) => {    
      let filteredRectangles = wall.rectangles.filter(rect => 
        !rect.cabinetConfig.includes("Adjacen") && 
        !rect.cabinetConfig.includes("placeholder") && 
        rect.cabinettype !== "appliances" &&
        !rect.cabinetConfig.includes("NoCorner")
      );
      let filteredWallRectangles = wall.wallrectangles.filter(rect => 
        !rect.cabinetConfig.includes("Adjacen") && 
        !rect.cabinetConfig.includes("placeholder") && 
        rect.cabinettype !== "appliances" &&
        !rect.cabinetConfig.includes("NoCorner")
      );      
      let combined = [...filteredRectangles, ...filteredWallRectangles];
      let cabs = combined.map(cab => {
        cab.wallname = wall.wallname;        
        return cab;
      });

      return cabs;
    })

    console.log(cabslist);

    let finalbodyarray = [];

    pdf.addImage(imageData, 'PNG', 20, 50, 40, 50); // Add logo
    pdf.text('LIST OF CABINETS', 100, 30);
    pdf.text('Special Notes: ' + specialnotes, 100, 45);
    
    for (var i=0; i<cabslist.length; i++) {
      let bodyarray = cabslist[i].map(cab => { //bodyarray is an array of arrays
        const depth = (cab.cabinettype==="base_cabinet" || cab.cabinettype==="tall_cabinet")?24:13;
        return [
          cab.cabinetConfig,
          1,
          cab.width/inchtopointfactor + "x" + cab.height/inchtopointfactor + "x" + depth,
          cab.shapename,
          cab.wallname + " (position: " + (i+1) + ")"
        ];
      });
      finalbodyarray=([...finalbodyarray, ...bodyarray]);
    }

    finalbodyarray.push(["Total Base Cabinet Width", "", Math.round((totalBaseWidth + Number.EPSILON)*100)/100 + " in", "", ""]);      

    /*
    const bodyarray = cabslist[0].map(cab => { //////////////////////////////////////////////////////////////////////
      return [
        cab.cabinetConfig,
        1,
        cab.width/inchtopointfactor + "x" + cab.height/inchtopointfactor,
        cab.shapename,
        cab.wallname
      ];
    });
    */

    // 📊 Add the table
    autoTable(pdf, {
      head: [headerarray],
      body: finalbodyarray,
      startY: 120, // 👈 Push table below the text
    });    

    pdf = addWaterMark(pdf);

    pdf.save('Kitchen Elevations Layout from Quicks Cabinet.pdf'); // Save the PDF
  };


    
  // keyValObject is on object with the keys and values that will be updated or added
  // example: keyValObject = {x: newX, y: newY}
  const updatStates = (cabinetId, cabinettype, keyValObject) => {
    if (cabinettype === "wall_cabinet") {
      setWalls(prevWalls =>
        prevWalls.map((wall, index) =>
          parseInt(index) === parseInt(currentWallIndex)
            ? { ...wall, wallrectangles: wallrectangles.map((rectangle) => {
              if (rectangle.id === cabinetId) {
                return {...rectangle, ...keyValObject};
              }
              else {
                return rectangle;         
              }                  
            })}
            : wall
        )
      );   
                
      setWallRectangles(prevItems =>
        prevItems.map((item, i) => {
          if (item.id === cabinetId) {
            return {...item, ...keyValObject};
          }
          else {
            return item;          
          }
        })
      );    
    }
    else {
      setWalls(prevWalls =>
        prevWalls.map((wall, index) =>
          parseInt(index) === parseInt(currentWallIndex)
            ? { ...wall, rectangles: rectangles.map((rectangle) => {
              if (rectangle.id === cabinetId) {
                return {...rectangle, ...keyValObject};
              }
              else {
                return rectangle;         
              }                  
            })}
            : wall
        )
      );  
                
      setRectangles(prevItems =>
        prevItems.map((item, i) => {
          if (item.id === cabinetId) {
            console.log("cab id found");
            console.log(JSON.stringify(keyValObject));
            return {...item, ...keyValObject};
          }
          else {
            console.log("cab id not found");
            return item;          
          }
        })
      );  
    }

  };

  const initialLayout = [{
    cabinetId: null,
    xstart: 0,
    ystart: 0
  }];

  const handleDragBound = (pos) => {
    // for all cabinets
    const minX = 0; 
    const maxX = inchtopoint(currentWallwidth);

    var minY;
    var maxY;

    if (cabinettype === "wall_cabinet") {
      minY = -wally-3; // for wall cabinet
      maxY = inchtopoint(currentWallHeight)-wally-4; // for wall cabinet
    }
    else {
      minY = -inchtopoint(currentWallHeight-cabinetHeight); // for other
      maxY = 0+inchtopoint(cabinetHeight); // for other
    }
    
    const shapeWidth = inchtopoint(cabinetwidth); // Example
    const shapeHeight = inchtopoint(cabinetHeight); // Example

    const posx = pos.x;
    const posy = pos.y;

    const newX = Math.max(minX, Math.min(posx, maxX - shapeWidth));
    const newY = Math.max(minY, Math.min(posy, maxY - shapeHeight));

    return { x: newX, y: newY };
  };  

  const dragStart = (e, id) => {
    const cabinettype = e.target.attrs.cabinettype;  
    
    var rectangle;
    if (cabinettype === "wall_cabinet") {
      rectangle = wallrectangles.find((r) => r.id === id);
    }
    else {
      rectangle = rectangles.find((r) => r.id === id);
    } 
    initialPositionsRef.current[id] = {
      x: rectangle.x,
      y: rectangle.y,
    };
  };

  const dragEnd = (e, id) => {
    const cabinetId = e.target.attrs.id;  
    const cabinettype = e.target.attrs.cabinettype;  
    let rectsArray; 
    
    console.log(e.target.attrs.x, e.target.attrs.y);

    const newX = e.target.attrs.x;
    const newY = e.target.attrs.y;  

    console.log({...e.target.attrs, ...e.target.children[0].attrs});
    switch (cabinettype) {
      case "wall_cabinet":
        rectsArray = wallrectangles;
        break;
      default:
        rectsArray = rectangles;
        break;

    }
    if (checkCollision({...e.target.attrs, ...e.target.children[0].attrs}, [...rectangles, ...wallrectangles])) {         
      //updatStates(cabinetId, cabinettype, {x: newX, y: newY, fill: collisionColor});
      //console.log("Collision detected");
      //console.log(xbeforeDrag, ybeforeDrag);
      //updatStates(cabinetId, cabinettype, {x: xbeforeDrag, y: ybeforeDrag, fill: collisionColor});
      //updatStates(cabinetId,cabinettype, {fill: collisionColor});
      const original = initialPositionsRef.current[id];
      if (shapeRefs.current[id]) {
        shapeRefs.current[id].position(original);
        shapeRefs.current[id].getLayer().batchDraw();
      }
    }
    else {
      updatStates(cabinetId, cabinettype, {x: newX, y: newY, fill: cabinetColor});

    }
    
    
  }  

  const handleBoundingDropMove = (e) => {
    const layer = e.target.getLayer();
    const minX = wallx; 
    const maxX = wallx + inchtopoint(currentWallwidth);
    // we are strongly assume that all the dragable items will have this: e.target.children[0].attrs.cabinettype
    const cabinettype = e.target.children[0].attrs.cabinettype;
    //console.log(cabinettype);

    var minY;
    var maxY;

    if (cabinettype === "wall_cabinet") {
      minY = wally + inchtopoint(currentWallSoftHeight); // for wall cabinet
      maxY = wally + inchtopoint(currentWallSoftHeight); //inchtopoint(currentWallHeight) + wally; // for wall cabinet
    }
    else {
      //minY = wally;
      //maxY = inchtopoint(currentWallHeight) + wally;
      minY = inchtopoint(currentWallHeight - cabinetHeight) + wally;
      maxY = inchtopoint(currentWallHeight - cabinetHeight) + wally;
    }

    const shapeWidth = layer.children[0].attrs.width; 
    const shapeHeight = layer.children[0].attrs.height;    

    const newX = Math.max(minX, Math.min(e.target.x(), maxX - shapeWidth));
    const newY = Math.max(minY, Math.min(e.target.y(), maxY - shapeHeight));

    e.target.x(newX);
    e.target.y(newY);

  };  
  const initialPositionsRef = useRef({}); // Ref to store the position before dragging
  const shapeRefs = useRef({});

  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');

  // cabinet to be inserted
  const [cabinetHeight, setCabinetHeight] = useState(34.5);
  const [cabinetwidth, setCabinetWidth] = useState(12);  
  const [cabinettype, setCabinetType] = useState("base_cabinet");   

  // job interview
  const [jobname, setJobName] = useState("");
  const [jobaddress, setJobAddress] = useState("");
  const [duedate, setDuedate] = useState("");

  const [finishcabinets, setFinishCabinets] = useState([]);
  const [finishcabinetdoors, setFinishCabinetdoors] = useState([]);

  const [finishcabinet, setFinishCabinet] = useState(null);  
  const [finishcabinetdoor, setFinishCabinetDoor] = useState(null);   

  const [defaultbackfinish, setDefaultBackFinishCabinet] = useState(null);

  const [isModalVisible, setModalVisible] = useState(false);
  const [show, setShow] = useState(true);
  const toggleShow = () => setShow(!show);

  const initialTooltipProp = {
    text: '', visible: false, x: 0, y: 0, yfrom: 0, yto: 0
  };

  const [ytooltipProp, setYTooltipProp] = useState(initialTooltipProp);    
  const [xtooltipProp, setXTooltipProp] = useState(initialTooltipProp);    

  // all existing cabinets in the current wall

  // cabinet selected
  const [idselected, setIDselected] = useState(null);  

  // begin initial base corners
  const initialLeftCorner = {
    x: wallx,
    y: inchtopointfactor*95 + wally - inchtopointfactor*34.5,
    width: inchtopointfactor*2,
    height: inchtopointfactor*34.5,
    fill: "Gray",
    id: Date.now().toString(), // unique ID
    cabinettype: "base_cabinet",
    shapename: "left_corner",
    selected: false,
    cabinetConfig: AllCabinetConfigs.find(config => config.configid === "FillerEndPanel").configid            
  };

  let initialRightCorner = {... initialLeftCorner};
  initialRightCorner.x = inchtopointfactor*110 + wallx - inchtopointfactor*2;;
  initialRightCorner.shapename = "right_corner";
  initialRightCorner.id = (Date.now()+50).toString(); // unique ID  
  // end initial base corners

  // begin initial wall corners
  const initialWallLeftCorner = {
    x: wallx,    
    y: inchtopoint(10) + wally, //wallsoftheight
    width: inchtopointfactor*2,
    height: inchtopointfactor*36,
    fill: "Gray",
    id: Date.now().toString()+100, // unique ID
    cabinettype: "wall_cabinet",
    shapename: "left_corner",
    selected: false,
    cabinetConfig: AllCabinetConfigs.find(config => config.configid === "FillerEndPanel").configid            
  };

  let initialWallRightCorner = {... initialWallLeftCorner};
  initialWallRightCorner.x = inchtopointfactor*110 + wallx - inchtopointfactor*2;;
  initialWallRightCorner.shapename = "right_corner";
  initialWallRightCorner.id = (Date.now()+150).toString(); // unique ID  
  // end initial wall corners  

  /*
  const [rectangles, setRectangles] = useState([initialLeftCorner, initialRightCorner]);
  const [wallrectangles, setWallRectangles] = useState([initialWallLeftCorner, initialWallRightCorner]);  
  */
  const [rectangles, setRectangles] = useState(kitchenfastquotemode===0?[initialLeftCorner, initialRightCorner]:location.state?location.state.walls[0].rectangles:[initialLeftCorner, initialRightCorner]);
  const [wallrectangles, setWallRectangles] = useState(kitchenfastquotemode===0?[initialWallLeftCorner, initialWallRightCorner]:location.state?location.state.walls[0].wallrectangles:[initialWallLeftCorner, initialWallRightCorner]);   

  let initialWall = {
    id: Date.now().toString(), // unique ID of the wall
    wallx: wallx,
    wally: wally,
    wallwidth: 110,
    wallheight: 95,
    wallsoftheight: 10,
    wallname: 'New Wall',
    walldirection: 0,
    rectangles: [initialLeftCorner,initialRightCorner],
    wallrectangles: [initialWallLeftCorner, initialWallRightCorner],
  };

  if (location.state) {
    //console.log(kitchenfastquotemode);
    //console.log(location.state.walls);
    initialWall = location.state.walls[0];
  }
  else {

  }

  ////const [walls, setWalls] = useState(kitchenfastquotemode!==0?location.state.walls:[initialWall]); // already working partially
  const [walls, setWalls] = useState(location.state?location.state.walls:[initialWall]); 
  // current wall
  const [currentWallHeight, setCurrentWallHeight] = useState(initialWall.wallheight);
  const [currentWallwidth, setCurrentWallWidth] = useState(initialWall.wallwidth);
  const [currentWallSoftHeight, setCurrentWallSoftHeight] = useState(initialWall.wallsoftheight);  
  const [currentWallName, setCurrentWallName] = useState(initialWall.wallname);    
  const [currentWallIndex, setCurrentWallIndex] = useState(0);    
  const [cablayout, setCablayout] = useState(initialLayout);
  ////const [specialnotes, setSpecialNotes] = useState(kitchenfastquotemode===0?"":location.state.specialnotes);
  const [specialnotes, setSpecialNotes] = useState(location.state?location.state.specialnotes:"");

  const [newWallDirection, setNewWallDirection] = useState(-90);
  const cabinetConfigs = AllCabinetConfigs;

  const [cabinetConfigoptions, setCabinetConfigOptions] = useState([]);
  const [cabinetConfig, setCabinetConfig] = useState({});
  const [sumOfAngles, setSumOfAngles] = useState(0);
  const [zeroIndex, setZeroIndex] = useState(0);

  const [shouldDelete, setShouldDelete] = useState(false);
  const [saveAsNew, setSaveAsNew] = useState(false);

  const onChangeSaveAsNew = () => {
    setSaveAsNew(!saveAsNew);
  };
  
  const onChangeSpecialNotes = (e) => {
    setSpecialNotes(e.target.value);
  };

  const onChangeCabinetHeight = (e) =>{
    console.log(e.target.value);
    console.log(cabinetConfig);
    setCabinetHeight(parseFloat(e.target.value));
  }

  // cabinets
  const onChangeCabinetWidth = (e) =>{
    setCabinetWidth(parseFloat(e.target.value));
  }  
  
  const onChangeCabinetType = (e) =>{
    setCabinetType(e.target.value);
  }    

  const onChangeCabinetConfig = (e) => {
    setCabinetConfig(cabinetConfigs.find(obj => obj.configid === e.target.value));
    if (e.target.value === "CornerBaseCabinet") {
      setCabinetWidth(36);
    }
    else {
      /*
      console.log(e.target.value);
      if (e.target.value === ":wallMountRangeHoodElement") {
        setCabinetType("wall_cabinet");
        setCabinetConfig(cabinetConfigs.find(obj => obj.configid === ":wallMountRangeHoodElement"));
      }
      */
      setCabinetWidth(12);
    }    
  }

  const onChangeWallDirection = () => {
    setNewWallDirection(newWallDirection===90?-90:90); 
  };  

  const onChangeFinishCabinet = (e) => {
    let finishcabinetId = parseInt(e.target.value);
    //setFinishCabinet(finishcabinets.find(obj => obj.id === finishcabinetId) || {});   
    //setFinishCabinet(finishcabinets.find(obj => obj.id === finishcabinetId)?.id || null);   
    setFinishCabinet(finishcabinetId);
    setDefaultBackFinishCabinet(finishcabinets.find(fincab => fincab.id === finishcabinetId)?.defaultbackfinish || "");
  }  

  const onChangeFinishCabinetDoor = (e) => {
    let finishcabinetdoorId = parseInt(e.target.value);
    //setFinishCabinetDoor(finishcabinetdoors.find(obj => obj.id === finishcabinetdoorId) || {});   
    //setFinishCabinetDoor(finishcabinetdoors.find(obj => obj.id === finishcabinetdoorId)?.id || null);   
    setFinishCabinetDoor(finishcabinetdoorId);
  }   

  const onChangeJobName = (e) => {
    setJobName(e.target.value);
  }

  const onChangeJobAddress = (e) => {
    setJobAddress(e.target.value);
  }

  const onChangeDueDate = (e) => {
    setDuedate(new Date(dtFormatter(e.target.valueAsNumber,3)).valueOf());
  }

  const retrieveFinishCabinets = () => {
    ItemDataService.getItemByCategory({"itemcategory":"finish_cabinet_box_case", "itemcategoryval":1},"id","ASC")
    .then(response => {
      setFinishCabinets(response.data);
    })
    .catch(e => {
      console.log(e);
    });    
  } 
  
  const retrieveFinishCabinetDoors = () => {
    ItemDataService.getItemByCategory({"itemcategory":"finish_cabinet_door", "itemcategoryval":1},"id","ASC")
    .then(response => {
      setFinishCabinetdoors(response.data);
    })
    .catch(e => {
      console.log(e);
    }); 
  }    
  
  const retrieveVersionDataForJobInterview = (originalvals) => {
    if (location.state===null || !location.state.fastquotingcabinetversionId) {
      return;
    }
    // the user modified the original values
    // so we do not need to retrieve the original values again
    if (!originalvals) { 
      return;
    }
    FastQuotingCabinetVersionsDataService.findById(location.state.fastquotingcabinetversionId)
    .then(resp => {
      console.log("resp.data");
      console.log(resp.data);

      setJobName(resp.data.fastquotingcabinet.job.jobtitle);
      setJobAddress(resp.data.fastquotingcabinet.job.jobaddress);
      setDuedate(new Date(dtFormatter(resp.data.fastquotingcabinet.job.jobduedate,3)).valueOf());
      //setDuedate(resp.data.fastquotingcabinet.job.jobduedate);

      const fincabx = resp.data.finishcabinet;
      const fincabdoorx = resp.data.finishcabinetdoor;
      setFinishCabinet(parseInt(fincabx));
      setFinishCabinetDoor(parseInt(fincabdoorx));

      console.log("finishcabinets");
      console.log(finishcabinets);
      console.log(fincabx);
      console.log(finishcabinets.find(fincab => fincab.id === parseInt(fincabx))?.defaultbackfinish || "");

      setDefaultBackFinishCabinet(finishcabinets.find(fincab => fincab.id === parseInt(fincabx))?.defaultbackfinish || "");
    })
    .catch(err => {
      console.log(err);
      setShowerror(true);
      setErrmessage("An error occurred while retrieving cabinet quotes.");
    });
  };

  const onDeleteWall = () => {   
    console.log(currentWallIndex);
    const idxtodel = currentWallIndex;
    console.log(zeroIndex);
    if (currentWallIndex > zeroIndex) {
      setWalls(walls.filter((_,ri) => {return ri !== currentWallIndex;}));
      onMoveToLeftWall();
    }
    else if (currentWallIndex < zeroIndex) {
      //onMoveToRightWall();
      setZeroIndex(prevzeroindex => prevzeroindex - 1);
      setWalls(prevwalls => prevwalls.filter((_,ri) => {return ri !== idxtodel;}));
      setSumOfAngles(angle => angle - 90);
      // after deleting the wall, if you want to insert a wall again,
      // it will not recognize the direction of the wall correctly
      //setCurrentWallIndex(0);
      setRectangles(walls[idxtodel+1].rectangles);
      setWallRectangles(walls[idxtodel+1].wallrectangles);
    }
    else {
      setShowsuccess(false);
      setSuccmessage("");
      setShowerror(true);
      setErrmessage("Cannot delete the initial wall.");
    }    
  };

  const onDeleteCabinet = () => {
    console.log("Cabinet to delete: " + idselected);
    console.log(cabinettype);
    var rectSelected; 
    var rectIndex;
    var rectsToCheckCollision;
    var collisionDetected = false;
    
    console.log(idselected);
    if (cabinettype === 'wall_cabinet') {
      rectSelected = wallrectangles.find(rect => rect.id === idselected); //rectangles
      if (rectSelected.shapename === "left_corner" || rectSelected.shapename === "right_corner") {
        return;
      }      
      rectIndex = wallrectangles.findIndex(rect => rect.id === idselected); ////rectangles  
      rectsToCheckCollision = wallrectangles.filter((_, i) => {return i !== rectIndex});          
      rectsToCheckCollision = rectsToCheckCollision.map((item, i) => {
        if (i < rectIndex) {return item;} else {return {... item, x:item.x - rectSelected.width}}            
      });      
      rectsToCheckCollision.forEach(rectToCheckCollision => {
        if (checkCollision(rectToCheckCollision,rectangles)) {
          collisionDetected = true;
          return;
        };
      });
      if (collisionDetected) {
        if (!rectSelected.forTallCabinetId) {
          setSuccmessage("");
          setShowsuccess(false);
          setErrmessage("Collision detected. Cabinet not deleted.");
          setShowerror(true);
        }
        return;        
      }      
      setWalls(prevWalls =>
        prevWalls.map((wall, index) =>
          parseInt(index) === parseInt(currentWallIndex)
            ?{ ...wall, wallrectangles: rectsToCheckCollision}:wall
        )
      );  
      setWallRectangles(rectsToCheckCollision); 
    }
    else {
      rectSelected = rectangles.find(rect => rect.id === idselected); //rectangles
      if (rectSelected.shapename === "left_corner" || rectSelected.shapename === "right_corner") {
        return;
      }      
      rectIndex = rectangles.findIndex(rect => rect.id === idselected); ////rectangles      
      rectsToCheckCollision = rectangles.filter((_, i) => {return i !== rectIndex});
      rectsToCheckCollision = rectsToCheckCollision.map((item, i) => {
        if (i < rectIndex) {return item;} else {return {... item, x:item.x - rectSelected.width}}            
      });
      rectsToCheckCollision.forEach(rectToCheckCollision => {
        if (checkCollision(rectToCheckCollision,wallrectangles)) {
          collisionDetected = true;
          return;
        };
      });
      if (collisionDetected) {
        setSuccmessage("");
        setShowsuccess(false);
        setErrmessage("Collision detected. Cabinet not deleted.");
        setShowerror(true);
        return;        
      }
      setWalls(prevWalls =>
        prevWalls.map((wall, index) =>
          parseInt(index) === parseInt(currentWallIndex)
            ?{ ...wall, rectangles: rectsToCheckCollision}:wall
        )
      );   
      setRectangles(rectsToCheckCollision);   
      setTooltip(prev => {return({...prev, visible: false})});
    };
    setIDselected(null);
  };


  const onCabinetSelected = (e) => {
    let layer = e.target.getLayer();
    console.log(layer);
    const rectid = layer.attrs.id;    
    if (layer.attrs.selected) {
      setIDselected(null);
      setCabinetConfig({});
      if (layer.attrs.cabinettype === "wall_cabinet") {
        setWallRectangles(prevItems =>
          prevItems.map(item => ({
            ...item,
            selected: false,
          }))
        );  
      } 
      else {
        setRectangles(prevItems =>
          prevItems.map(item => ({
            ...item,
            selected: false,
          }))
        );  
      }
    
    }
    else {
      setCabinetType(layer.attrs.cabinettype);
      setIDselected(rectid);
      setCabinetWidth(layer.children[0].attrs.width/inchtopointfactor);

      setCabinetHeight(layer.children[0].attrs.height/inchtopointfactor);    
       
      setCabinetConfig(cabinetConfigs.find(cabconfig => cabconfig.configid === layer.attrs.cabinetConfig) || {});

      if (layer.attrs.cabinettype === "wall_cabinet") {

        setRectangles(prevItems =>
          prevItems.map(item => ({
            ... item,
            selected: false,
          }))
        );        
        setWallRectangles(prevItems =>
          prevItems.map(item => ({
            ... item,
            selected: rectid === item.id?true:false,
          }))
        );
        console.log("wall cabinet selected");

      }
      else {
        setRectangles(prevItems =>
          prevItems.map(item => ({
            ...item,
            selected: rectid === item.id?true:false,
          }))
        );
        setWallRectangles(prevItems =>
          prevItems.map(item => ({
            ... item,
            selected: false,
          }))
        );        
      }      
      /*
      if (layer.attrs.forTallCabinetId) {
        setShouldDelete(true); // change to true
      }
      */
    }
  }

  const evaluateCabinetLayout = (new_cab_id, new_cab_x, new_cab_y, new_cab_width, new_cab_height) => {

  }

  const onInsertCabinet = (cab) =>{ //cabinetConfig, cabinetwidth, cabinetHeight, 
    const cabinetConfig = cab.cabinetConfig;
    var cabType = cab.cabinettype;
    console.log("cabxx");
    console.log(cab); // cabinet to be inserted

    if ( Object.keys(cabinetConfig).length === 0) {
      setSuccmessage("");
      setShowsuccess(false);
      setErrmessage("Please, select a cabinet configuration.");
      setShowerror(true);
      return;      
    }    

    if (cabinetConfig.configid.toLowerCase().includes("applianceswindowelement".toLowerCase())) {
      cabType = "wall_cabinet";
      onInsertCabinet({
        cabinetConfig: AllCabinetConfigs.find(config => config.configid === ":upperwindowElement"),
        cabinetwidth: cab.cabinetwidth,
        cabinetHeight: cab.cabinetHeight,        
        cabinettype: "wall_cabinet",        
      });
      return;
    }

    if (cabinetConfig.configid.toLowerCase().includes("applianceswallMountRangeHoodElement".toLowerCase())) {
      cabType = "wall_cabinet";
      onInsertCabinet({
        cabinetConfig: AllCabinetConfigs.find(config => config.configid === ":upperwallMountRangeHoodElement"),
        cabinetwidth: cab.cabinetwidth,
        cabinetHeight: cab.cabinetHeight,        
        cabinettype: "wall_cabinet",        
      });
      return;
    }

    if (idselected===null) { 
      // before inserting a door panel
      // we need to make sure the cabinet at the left is compatible
      const compname = cab.cabinetConfig.configcomponentname.name;
      var verifyRectsLeft;    
      if (cabType === "wall_cabinet") {
        verifyRectsLeft = wallrectangles.filter(rect => rect.shapename !== "right_corner"); 
      }
      else {
        verifyRectsLeft = rectangles.filter(rect => rect.shapename !== "right_corner");  
      }    

      let verifyRectsLeftLength = verifyRectsLeft.length;
      let lastRect = {};

      console.log(compname);
      console.log(verifyRectsLeftLength);
      console.log(lastRect.cabinetConfig);

      console.log(cabType);

      if (verifyRectsLeftLength > 0) {  
        lastRect = verifyRectsLeft[verifyRectsLeftLength-1];  
        console.log("lastRect");
        console.log(lastRect);
        let lastrectisdoorpanel = lastRect.cabinetConfig.toLowerCase().includes("doorpanel");

        if (compname === "BaseWallTallDoorPanel") { // if I want to insert a door panel...
          if (!lastRect.cabinetConfig.toLowerCase().includes("placeholder") && !lastRect.cabinetConfig.toLowerCase().includes("nocorner")) { // last rectangle is not a placeholder.
            // last rectangle is a filler panel or a door panel or the cabinet type of the last panel doesn't math the cabinet type of the door panel
            // this condition: lastRect.cabinettype !== cabType seems to be too strict 
            // because it does not allow to insert a door panel next to a cabinet if the cabinet type is different from the door panel cabinet type, 
          
            if (lastRect.cabinetConfig === "FillerEndPanel" || lastrectisdoorpanel) { // (lastRect.cabinettype !== cabType)
              setSuccmessage("");
              setShowsuccess(false);
              setErrmessage("Cannott insert a door panel next to this type of cabinet.");
              setShowerror(true);          
              return;
            }
          }
          else { // last rectangle is a placeholder
            // it should be ok to insert any door panel here.
          }        
        }
      
        if (lastrectisdoorpanel) { // last rect is a door panel
          if (!cabinetConfig.configid.toLowerCase().includes("placeholder")) { // the panel that I want to insert is not a placeholder
            /*
            if (lastRect.cabinettype !== cabType) { // the panel that I want to insert is not the same type as the last rectangle
              setSuccmessage("");
              setShowsuccess(false);
              setErrmessage("Cannot insert a cabinet next to a door panel. If you want to insert a cabinet, please delete the existing door panel.");
              setShowerror(true);                    
              return;
            }
            else {

            }
            */
          } 
          else {

          }
        } 
        else { // last rect is not a door panel
          //

        }
      }
    }

    let cabinetConfigWidthMin = cabinetConfig.widthMin;
    let cabinetConfigWidthMax = cabinetConfig.widthMax;   
    let allowedHeights = cabinetConfig.allowedHeights;
    let notStandard = false;
    
    const cabinetwidth = cab.cabinetwidth; 

    if ((cabinetwidth > cabinetConfigWidthMax) || (cabinetwidth < cabinetConfigWidthMin)) {
      notStandard = true;
    }

    
    const cabinetHeight = cab.cabinetHeight;     
    if (allowedHeights && allowedHeights.length > 0) {
      if (!allowedHeights.includes(cabinetHeight)) {
        notStandard = true;
      }
    }    

    let width = inchtopoint(cabinetwidth); 
    const cabinettype = cab.cabinettype;       

    let totalCurrentWidth = 0;
    let widthDifference = 0;
    let heightDifference = 0;
    let count = 0;
    let index = 0;
    const targetKey = 'cabinettype';
    const targetValue = cabinettype;  

    let height = inchtopoint(parseFloat(cabinetHeight)); //parseInt(,10)?
    /*
    height = ((cabinettype==="base_cabinet" || cabinettype==="tall_cabinet") && (!cabinetConfig.toLowerCase().includes("filler")) && (!cabinetConfig.toLowerCase().includes("placeholder"))) ? 
      height-4*inchtopointfactor : 
      height;    
    */

    let baseheightnotoekick;
    if ((cabinettype==="base_cabinet" || cabinettype==="tall_cabinet") && (!cabinetConfig.configname.toLowerCase().includes("filler")) && (!cabinetConfig.configname.toLowerCase().includes("placeholder"))) {
      baseheightnotoekick = height-4*inchtopointfactor;
    }

    if (!height) return; //width 

    //if (height > inchtopoint(currentWallHeight)) {
    if (height > inchtopoint(walls[currentWallIndex].wallheight)) {
      setSuccmessage("");
      setShowsuccess(false);
      setErrmessage("Not enough wall height to insert the cabinet.");
      setShowerror(true);
      return;
    }

    var fill;
    fill = cabinetColor;
    let x; 
    var y;

    var newRectCabinetType = [];
    
    switch (cabinettype) {    
      case "wall_cabinet":        
        y = inchtopoint(walls[currentWallIndex].wallsoftheight) + wally;        
        newRectCabinetType = wallrectangles;
        break;   
      default:      
        y = inchtopoint(walls[currentWallIndex].wallheight) + wally - height;                
        //y = inchtopoint(walls[currentWallIndex].wallheight) + wally - baseheightnotoekick;    //////////////////////////////////////             
        newRectCabinetType = rectangles;
        break;
    }

    var rightCornerWidth = 0;
    var shapename ="";
 
    for (const item of newRectCabinetType) {
      console.log(item);
      if (item.shapename !== "right_corner") {
        totalCurrentWidth += item.width;
      }
      else {
        rightCornerWidth = item.width;
      }
        
      if (item[targetKey] === targetValue) {
        count++;
      }      
    }
    count++;

    var originalRectCabinetType = [];
    
    var rectanglesselected = rectangles.filter(rectangle => rectangle.selected);
    var wallrectanglesselected = wallrectangles.filter(rectangle => rectangle.selected);
    let rectSelected = {};
    var PlaceholderForTallCabinet = {};

    if (rectanglesselected.length > 0) {
      console.log("base, tall or appliance cabinet selected");
      originalRectCabinetType = rectangles; //rectanglesselected; //
      shapename = rectanglesselected[0].shapename;
    }
    else if (wallrectanglesselected.length > 0) {
      console.log("wall cabinet selected");
      originalRectCabinetType = wallrectangles; //wallrectanglesselected; // 
      shapename = wallrectanglesselected[0].shapename;
    }
    else {
      console.log("no cabinet selected");
      shapename = cabinettype + "_" + count;
    }
      
    /*
    console.log(shapename);
    console.log(totalCurrentWidth);
    */

    if (idselected === null) {
      x = totalCurrentWidth + wallx;   
      widthDifference = width;           
    }
    else {      
      rectSelected = originalRectCabinetType.find(rect => rect.id === idselected); //rectangles      
      index = originalRectCabinetType.findIndex(rect => rect.id === idselected); //rectangles
      if (rectSelected.shapename === "right_corner") {
        /*
        console.log(rectSelected.x);
        console.log(widthDifference);
        */
        x = rectSelected.x - (width - rectSelected.width);     
      }
      else {
        x = rectSelected.x;   
        let rectSelectedCurrentWidth = rectSelected.width;
        console.log(width,rectSelectedCurrentWidth,widthDifference);
        widthDifference = width - rectSelectedCurrentWidth;  
        /*            
        if (rectSelected.cabinettype === "tall_cabinet") {
          PlaceholderForTallCabinet = walls[currentWallIndex].wallrectangles.find(rect => rect.forTallCabinetId === rectSelected.id);
          updatStates(PlaceholderForTallCabinet.id, "wall_cabinet", {width: width});
        }
        */
      }
      
      let rectSelectedCurrentWidth = rectSelected.width;
      console.log(width,rectSelectedCurrentWidth,widthDifference);
      widthDifference = width - rectSelectedCurrentWidth;            

      let rectSelectedCurrentHeight = rectSelected.height;
      heightDifference = height - rectSelectedCurrentHeight;                                 
      //heightDifference = baseheightnotoekick - rectSelectedCurrentHeight;                                 
      y = cabinettype==="wall_cabinet"?rectSelected.y:rectSelected.y - heightDifference;  
    }
    console.log("--------");
    console.log(totalCurrentWidth);
    console.log(widthDifference);
    console.log(inchtopoint(walls[currentWallIndex].wallwidth));
    console.log(rightCornerWidth);
    console.log(cabinetHeight);
    console.log(height);
    console.log("--------");  

    if (totalCurrentWidth + widthDifference > inchtopoint(walls[currentWallIndex].wallwidth) - rightCornerWidth) {
      setSuccmessage("");
      setShowsuccess(false);
      setErrmessage("Not enough wall width for the cabinet.");
      setShowerror(true);
      return;
    }   

    if (y < wally) {
      setSuccmessage("");
      setShowsuccess(false);
      setErrmessage("Not enough wall height for the cabinet.");
      setShowerror(true);
      return;
    }     

    /*
    if (x + width > wallx + inchtopoint(currentWallwidth)) {
      setSuccmessage("");
      setShowsuccess(false);
      setErrmessage("Not enough wall width for the cabinet.");
      setShowerror(true);
      return;
    } */   

    if ((idselected === null) && (cabinettype === "tall_cabinet")) {
      const diffHeightWithSoftHeight = inchtopoint(walls[currentWallIndex].wallsoftheight) + wally - y;
      if (diffHeightWithSoftHeight>0) {
        height = height - diffHeightWithSoftHeight;
        y = y + diffHeightWithSoftHeight;
      };              
    }
    /*
    else if (cabinetConfig.configid.toLowerCase() === "r:2dr-lp") {
      alert();
      height = inchtopoint(walls[currentWallIndex].wallheight) - inchtopoint(walls[currentWallIndex].wallsoftheight) - wally;
      //y = y + diffHeightWithSoftHeight;      
    }
    */

    const newRect = {
      x: x + (cab.prevcabwidth?inchtopoint(cab.prevcabwidth):0), 
      y: y, 
      //y: y-4*inchtopointfactor,
      xdrag: x,
      ydrag: y,
      width,
      height,
      //height:baseheightnotoekick,

      stroke:notStandard?"#9C0006":"Black",
      fill: fill,
      id: idselected?idselected:Date.now().toString(), // unique ID
      cabinettype: cabinettype,
      shapename: shapename,
      selected: false,

      cabinetConfig: cabinetConfig.configid,
      side: cabinetConfig.side,
      panelSide: cabinetConfig.panelSide,
      numDrawersFronts: cabinetConfig.numDrawersFronts,
      numshelves: cabinetConfig.numshelves,
      cornerside: cabinetConfig.cornerside,
      forTallCabinetId: cabinetConfig.forTallCabinetId,

      compDrawers: cabinetConfig.compDrawers,
      compRollouts: cabinetConfig.compRollouts,
    };
    /*
    if (!idselected) {
      newRect.id = Date.now().toString();
    };
    */

    let leftCornerHeight, rightCornerHeight;
    let wallLeftCornerHeight, wallRightCornerHeight;
    let leftCornerY, rightCornerY;      

    switch (cabinettype) {   
      case "wall_cabinet":   

        if (checkCollision(newRect, rectangles)) {
          setShowsuccess(false);
          setSuccmessage("");
          setShowerror(true);
          setErrmessage('🚫 Collision detected! Cabinet not inserted.');
          return;
        }   

        if (idselected) {
          console.log("we are checking collisions for wall cabinet when updating existing cabinet");
          const newWallRectangles = wallrectangles.map((item, i) => {
            if (item.id === idselected) {
              return newRect;
            }
            else {
              if (i > index && item.shapename !== "right_corner" && rectSelected.shapename !== "right_corner") {
                return {... item, x:item.x + widthDifference}
              }
              else {
                return item;
              }            
            }
          });        

          let collisionDetected = false;
          for (const rect of [...rectangles, ...newWallRectangles]) {
            collisionDetected = checkCollision(rect, [...rectangles, ...newWallRectangles]);
            console.log(collisionDetected);
            if (collisionDetected) {
              break;
            }
          }        
          
          if (collisionDetected) {
            setShowsuccess(false);
            setSuccmessage("");
            setShowerror(true);
            setErrmessage('🚫 Collision detected! Cabinet not inserted.');
            return;
          };        
        }

        /* 
        if (checkCollision(newRect, wallrectangles)) {
          setShowsuccess(false);
          setSuccmessage("");
          setShowerror(true);
          setErrmessage('🚫 Collision detected! Cabinet not inserted.');
          return;
        } 
        */                 

        if (idselected===null) { 

          //////////////////////////////

          console.log(cabinetConfig);

          if (cabType === "wall_cabinet" && (cabinetConfig.configname.toLowerCase().includes("fridge") || cabinetConfig.configname.toLowerCase().includes("hood"))) {
            console.log("inserting a fridge cabinet, first insert a tall door panel");
            if (cabinetConfig.configname.toLowerCase().includes("fridge")) {
              if (cabinetConfig.panelSide.toLowerCase().includes("l")) {
                // inserting or saving a fridge cabinet
                // first insert a tall door panel
                const cont = onInsertCabinet({
                  cabinetConfig: AllCabinetConfigs.find(config => config.configid === "PanelForWallF"),
                  cabinetwidth: 0.75,
                  cabinetHeight: walls[currentWallIndex].wallheight - walls[currentWallIndex].wallsoftheight,
                  cabinettype: "wall_cabinet",
                },newRect);
                if (cont) {
                  newRect.x += inchtopoint(0.75);
                }
                else {
                  return;
                }
              }
              
              // then insert the fridge cabinet
            }
            else if (cabinetConfig.configname.toLowerCase().includes("hood")) {

            }
          }

          /////////////////////////////   
                    
          setWalls(prevWalls =>
            [... prevWalls.slice(0, currentWallIndex),
              { ...prevWalls[currentWallIndex], wallrectangles: [...prevWalls[currentWallIndex].wallrectangles, newRect]},
            ... prevWalls.slice(currentWallIndex + 1)]
            /*
            prevWalls.map((wall, index) =>
              parseInt(index) === parseInt(currentWallIndex)
                ? { ...wall, wallrectangles: [...wallrectangles, newRect]}
                : wall
            )
            */
          );
          setWallRectangles(prevItems => [...prevItems, newRect]);

          //////////////////////////////

          console.log(cabinetConfig);

          if (cabType === "wall_cabinet" && (cabinetConfig.configname.toLowerCase().includes("fridge") || cabinetConfig.configname.toLowerCase().includes("hood"))) {
            console.log("inserting a fridge cabinet, first insert a tall door panel");
            if (cabinetConfig.configname.toLowerCase().includes("fridge")) {
              if (cabinetConfig.panelSide.toLowerCase().includes("r")) {
                let panwidth = 0;
                // inserting or saving a fridge cabinet
                // first insert a tall door panel
                if (cabinetConfig.panelSide.toLowerCase().includes("l")) {
                  // both sides
                  panwidth = 0.75;
                }
                const cont = onInsertCabinet({
                  cabinetConfig: AllCabinetConfigs.find(config => config.configid === "PanelForWallF"),
                  cabinetwidth: 0.75,
                  cabinetHeight: walls[currentWallIndex].wallheight - walls[currentWallIndex].wallsoftheight,
                  cabinettype: "wall_cabinet",
                  prevcabwidth: cabinetwidth + panwidth,
                });
                /*
                if (cont) {
                  newRect.x += inchtopoint(0.75);
                }
                else {
                  return;
                }
                */
              }
              
              // then insert the fridge cabinet
            }
            else if (cabinetConfig.configname.toLowerCase().includes("hood")) {

            }
          }

          /////////////////////////////             
        }
        else {       

          setWalls(prevWalls =>
            prevWalls.map((wall, iwall) =>
              parseInt(iwall) === parseInt(currentWallIndex)? 
                { ...wall, wallrectangles: 
                  wallrectangles.map((rectangle, ri) => {
                  if (rectangle.id === idselected) {
                    return newRect;
                  }
                  else {
                    if (ri > index && rectangle.shapename !== "right_corner" && rectSelected.shapename !== "right_corner") {
                      return {... rectangle, x:rectangle.x + widthDifference}
                    }
                    else {
                      return rectangle;
                    }            
                  }                  
                })} 
                :parseInt(iwall) + 1 === parseInt(currentWallIndex)?
                { ...wall, 
                  wallrectangles: wall.wallrectangles.map((rectangle, ri) => {
                    console.log(ri);
                    console.log(rectangle);                    
                    if (rectangle.shapename === "right_corner") {
                      wallLeftCornerHeight = newRect.height;
                      leftCornerY = inchtopointfactor*wall.wallheight + wally - leftCornerHeight;
                      return {... rectangle, height:wallLeftCornerHeight}
                    }
                    else {
                      return rectangle;
                    }            
                  },
                )}  
                :parseInt(iwall) - 1 === parseInt(currentWallIndex)?
                { ...wall, 
                  wallrectangles: wall.wallrectangles.map((rectangle, ri) => {
                    console.log(ri);
                    console.log(rectangle);
                    if (rectangle.shapename === "left_corner") { ////rectangle.shapename === "left_corner"
                      wallRightCornerHeight = newRect.height;
                      rightCornerY = inchtopointfactor*wall.wallheight + wally - rightCornerHeight;
                      return {... rectangle, height:wallRightCornerHeight}
                    }
                    else {
                      return rectangle;
                    }            
                  },
                )}                           
                : wall
            )
          );     


          //// original
          /*
          setWalls(prevWalls =>
            prevWalls.map((wall, iwall) =>
              parseInt(iwall) === parseInt(currentWallIndex)
                ? { ...wall, wallrectangles: wallrectangles.map((rectangle, ri) => {
                  if (rectangle.id === idselected) {
                    return newRect;
                  }
                  else {
                    if (ri > index && rectangle.shapename !== "right_corner" && rectSelected.shapename !== "right_corner") {
                      return {... rectangle, x:rectangle.x + widthDifference}
                    }
                    else {
                      return rectangle;
                    }            
                  }                  
                })}
                : wall
            )
          );  
          */

                    
          setWallRectangles(prevItems =>
            prevItems.map((item, i) => {
              if (item.id === idselected) {
                return newRect;
              }
              else {
                if (i > index && item.shapename !== "right_corner" && rectSelected.shapename !== "right_corner") {
                  return {... item, x:item.x + widthDifference}
                }
                else {
                  return item;
                }            
              }
            })
          );   
        }

        break;

      default:
        console.log("we are checking collisions");
        if (checkCollision(newRect, wallrectangles)) {
          setShowsuccess(false);
          setSuccmessage("");
          setShowerror(true);
          setErrmessage('🚫 Collision detected! Rectangle not inserted.');
          return;
        }        

        if (idselected) {
          console.log("we are checking collisions for base cabinet when updating existing cabinet");
          const newRectangles = rectangles.map((item, i) => {
            if (item.id === idselected) {
              return newRect;
            }
            else {
              if (i > index && item.shapename !== "right_corner" && rectSelected.shapename !== "right_corner") {
                return {... item, x:item.x + widthDifference}
              }
              else {
                return item;
              }            
            }
          });        

          let collisionDetected = false;
          for (const rect of [...newRectangles, ...wallrectangles]) {
            collisionDetected = checkCollision(rect, [...newRectangles, ...wallrectangles]);
            console.log(collisionDetected);
            if (collisionDetected) {
              break;
            }
          }        
          
          if (collisionDetected) {
            setShowsuccess(false);
            setSuccmessage("");
            setShowerror(true);
            setErrmessage('🚫 Collision detected! Cabinet not inserted.');
            return;
          };        
        }

        if (idselected===null) { 
          setWalls(prevWalls =>
            prevWalls.map((wall, index) =>            
              parseInt(index) === parseInt(currentWallIndex)
                ? { ...wall, rectangles: [...rectangles, newRect]}
                : wall
            )
          );

          setRectangles(prevItems => [...prevItems, newRect]);
        }
        else {                  
          let continueFlag = true;
          setWalls(prevWalls =>
            prevWalls.map((wall, iwall) =>
              parseInt(iwall) === parseInt(currentWallIndex)? 
                { ...wall, rectangles: 
                  rectangles.map((rectangle, ri) => {
                  console.log("equal");
                  if (rectangle.id === idselected) {
                    return newRect;
                  }
                  else {
                    if (ri > index && rectangle.shapename !== "right_corner" && rectSelected.shapename !== "right_corner") {
                      return {... rectangle, x:rectangle.x + widthDifference}
                    }
                    else {
                      return rectangle;
                    }            
                  }                  
                })} 
                :((parseInt(iwall) + 1 === parseInt(currentWallIndex)) && true)?
                { ...wall, 
                  rectangles: wall.rectangles.map((rectangle, ri) => { 
                    console.log("+1");
                    continueFlag = false;                
                    if ((rectangle.shapename === "right_corner") && (newRect.shapename === "left_corner")) {
                      leftCornerHeight = newRect.height;
                      leftCornerY = inchtopointfactor*wall.wallheight + wally - leftCornerHeight;
                      return {... rectangle, height:leftCornerHeight, y:leftCornerY}
                    }
                    else {
                      return rectangle;
                    }            
                  },
                )}  
                :((parseInt(iwall) - 1 === parseInt(currentWallIndex)) && true)?
                { ...wall, 
                  rectangles: wall.rectangles.map((rectangle, ri) => {
                    console.log("-1");
                    console.log(ri);
                    console.log(rectangle);
                    if ((rectangle.shapename === "left_corner") && (newRect.shapename === "right_corner")) {
                      rightCornerHeight = newRect.height;
                      rightCornerY = inchtopointfactor*wall.wallheight + wally - rightCornerHeight;
                      return {... rectangle, height:rightCornerHeight, y:rightCornerY}
                    }
                    else {
                      return rectangle;
                    }            
                  },
                )}                           
                : wall
            )
          );     
          
          ////original
          /*
          setWalls(prevWalls =>
            prevWalls.map((wall, iwall) =>
              parseInt(iwall) === parseInt(currentWallIndex)? 
                { ...wall, rectangles: 
                  rectangles.map((rectangle, ri) => {
                  if (rectangle.id === idselected) {
                    return newRect;
                  }
                  else {
                    if (ri > index && rectangle.shapename !== "right_corner" && rectSelected.shapename !== "right_corner") {
                      return {... rectangle, x:rectangle.x + widthDifference}
                    }
                    else {
                      return rectangle;
                    }            
                  }                  
                })} 
                : wall
            )
          );
          */  
          
          setRectangles(prevItems =>
            prevItems.map((item, i) => {
              if (item.id === idselected) {
                return newRect;
              }
              else {
                if (i > index && item.shapename !== "right_corner" && rectSelected.shapename !== "right_corner") {
                  return {... item, x:item.x + widthDifference}
                }
                else {
                  return item;
                }            
              }
            })
          );
          

          //console.log({attrs:{forTallCabinetId:PlaceholderForTallCabinet.forTallCabinetId,id:PlaceholderForTallCabinet.id,selected:false,cabinettype:'wall_cabinet',cabinetConfig:PlaceholderForTallCabinet.cabinetConfig},children:[{attrs:{width:PlaceholderForTallCabinet.width,height:PlaceholderForTallCabinet.height}}]});
          //onCabinetSelected({target:{getLayer:()=>{return {attrs:{forTallCabinetId:PlaceholderForTallCabinet.forTallCabinetId,id:PlaceholderForTallCabinet.id,selected:false,cabinettype:'wall_cabinet',cabinetConfig:PlaceholderForTallCabinet.cabinetConfig},children:[{attrs:{width:PlaceholderForTallCabinet.width,height:PlaceholderForTallCabinet.height}}]}}}});          
        }
    }   
    setIDselected(null); 
    return newRect;   
  }  

  const addElementToTheWall = (props) => (
    <Tooltip id='add-element' {...props}>
      Add object to the wall
    </Tooltip>
  );  

  const deleteElementFromTheWall = (props) => (
    <Tooltip id='add-element' {...props}>
      Delete selected object
    </Tooltip>
  );    

  const leftWallTooltip = (props) => (
    <Tooltip id="left-wall-tooltip" {...props}>
      Insert Left Wall
    </Tooltip>
  );  

  const rightWallTooltip = (props) => (
    <Tooltip id="right-wall-tooltip" {...props}>
      Insert Right Wall
    </Tooltip>
  );  

  const moveleftWallTooltip = (props) => (
    <Tooltip id="move-left-tooltip" {...props}>
      Move to the Left Wall
    </Tooltip>
  );  

  const doubleClickToInsertTooltip = (props) => (
    <Tooltip id="double-click-tooltip" {...props}>
      Double Click to Insert
    </Tooltip>
  );  

  const moverightWallTooltip = (props) => ( //moverightWallTooltip
    <Tooltip id="move-right-tooltip" {...props}>
      Move to the Right Wall
    </Tooltip>
  );  

  const saveCabinetTooltip = (props) => { //saveCabinetTooltip
    <Tooltip {...props}>
      S
    </Tooltip>    
  };

  const frontalWallTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Wall Name: {currentWallName}
    </Tooltip>
  );    

  const cabinetWidthTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Cabinet Width: {cabinetwidth}" 
    </Tooltip>
  );
  
  const onMoveToRightWall = () => { // async?
    let curri;
    //await delay(3000)
    //.then(() => {
      if (currentWallIndex === walls.length - 1) {
        /*
        setShowsuccess(false);
        setSuccmessage("");
        setShowerror(true);
        setErrmessage("You are already in the last wall.");   
        */
        return;   
      }
      else {
        curri = currentWallIndex + 1;
        const newrects = walls[curri].rectangles;
        const newwallrects = walls[curri].wallrectangles;
        setCurrentWallIndex(curr => curr + 1); 
        // I'm now changing these states using a useEffect hook that runs when currentWallIndex changes.
        // TODO: monitor this update and make sure it doesn' affect any other functionality
        //setRectangles(walls[curri].rectangles);
        //setWallRectangles(walls[curri].wallrectangles);

        setIDselected(null);
        if (curri > zeroIndex) {
          setSumOfAngles(sumOfAngles + parseInt(walls[curri].walldirection));
        }
        else if (curri < zeroIndex) {
          setSumOfAngles(sumOfAngles - parseInt(walls[curri].walldirection));
        }
        else {
          setSumOfAngles(0);
        }      
      } 
    //});
  };

  const onMoveToLeftWall = () => {
    if (currentWallIndex === 0) {
      /*
      setShowsuccess(false);
      setSuccmessage("");
      setShowerror(true);
      setErrmessage("You are already in the first wall.");      
      */
      return;
    }
    else {
      setCurrentWallIndex(currentWallIndex-1); 
      setRectangles(walls[currentWallIndex-1].rectangles);
      setWallRectangles(walls[currentWallIndex-1].wallrectangles);
      setIDselected(null);
      if (currentWallIndex - 1 > zeroIndex) {
        setSumOfAngles(sumOfAngles + parseInt(walls[currentWallIndex-1].walldirection));
      }
      else if (currentWallIndex - 1 < zeroIndex) {
        setSumOfAngles(sumOfAngles + parseInt(walls[currentWallIndex-1].walldirection));
      }
      else {
        setSumOfAngles(0);
      }
    }      
  };  

  const mouseOverMainLayer = (e) => {
    const mousePos = e.target.getStage().getPointerPosition();

    let rectInPos = rectangles.find(rect => rect.x <= mousePos.x && rect.x + rect.width >= mousePos.x);
    let wallrectInPos = wallrectangles.find(rect => rect.x <= mousePos.x && rect.x + rect.width >= mousePos.x);
    let yfrom, yto;
    if (rectInPos && wallrectInPos) {


      yfrom = wallrectInPos.y + wallrectInPos.height;
      yto = rectInPos.y - (wallrectInPos.y + wallrectInPos.height + coverheight*inchtopointfactor);

      if (yfrom <= mousePos.y ) {
        // inside the area between the two cabinets
        let ymeasure = yto/inchtopointfactor;
        setYTooltipProp({
          text: `y_d=${Math.round((ymeasure + Number.EPSILON) * 100) / 100}`,
          visible: true,
          x: mousePos.x - 20,
          y: mousePos.y - 20,
          yfrom: yfrom,
          yto: yto
        });            
      }  
      else {     
        setYTooltipProp(initialTooltipProp);
      }   
    }
    else {
      setYTooltipProp(initialTooltipProp);
    }
    
    let leftRectInPos = [...rectangles, ...wallrectangles].filter(
      rect => !(rect.cabinetConfig.toLowerCase().includes("placeholder")) && rect.y <= mousePos.y && rect.y + rect.height >= mousePos.y && rect.x + rect.width <= mousePos.x
    );
    let rightRectInPos = [...rectangles, ...wallrectangles].filter(
      rect => rect.y <= mousePos.y && rect.y + rect.height >= mousePos.y && rect.x >= mousePos.x
    );
    if (leftRectInPos.length>0 && rightRectInPos.length>0) {

      const maxLeftRectInPos = leftRectInPos.reduce((maxObj, currentObj) =>
        currentObj.x > maxObj.x ? currentObj : maxObj
      );
      const minRightRectInPos = rightRectInPos.reduce((minObj, currentObj) =>
        currentObj.x < minObj.x ? currentObj : minObj
      );

      let xfrom, xto;
      xfrom = maxLeftRectInPos.x + maxLeftRectInPos.width;
      xto = minRightRectInPos.x;
      if (xfrom <= mousePos.x && mousePos.x <= xto) {
        // inside the area between the two cabinets
        let xmeasure = (xto - xfrom)/inchtopointfactor;
        setXTooltipProp({
          text: `x_d=${Math.round((xmeasure + Number.EPSILON) * 100) / 100}`,
          visible: true,
          x: mousePos.x - 20,
          y: mousePos.y - 20,
          xfrom: xfrom,
          xto: xto
        });   
      }  
      else {     
        setXTooltipProp(initialTooltipProp);
      }
      
    }
    else {
      setXTooltipProp(initialTooltipProp);
    }
    
  }

  const mouseLeaveMainLayer = (e) => {
    setXTooltipProp(initialTooltipProp);
    setYTooltipProp(initialTooltipProp);
  };     

  const onInsertWall = (
    initwall, side, mode, leftcorner, rightcorner, 
    wallleftcorner, wallrightcorner, 
    previousBaseLeftCornerWidth, previousWallLeftCornerWidth,
    newAdjacentLeftCorner, newAdjacentRightCorner,
    newAdjacentWallLeftCorner, newAdjacentWallRightCorner
  ) =>{
    console.log(initialWall);
    console.log(leftcorner);
    
    // if there is already a wall at the left (right) of the current wall
    // we will not allow to insert another one to the left (right)
    const newWall = {...initwall}; 
    
    /*
    console.log(newWall);
    console.log(initwall);
    console.log("walls");
    console.log(walls);
    console.log("newAdjacentRightCorner");
    console.log(newAdjacentRightCorner);
    console.log("newAdjacentLeftCorner");
    console.log(newAdjacentLeftCorner);    
    console.log("newAdjacentWallLeftCorner");
    console.log(newAdjacentWallLeftCorner);    
    console.log("newAdjacentWallRightCorner");
    console.log(newAdjacentWallRightCorner);
    console.log(leftcorner);
    console.log(rightcorner);
    console.log(side);
    console.log(wallleftcorner);
    */

    /*
    let currentWallBaseLeftCorner = walls[currentWallIndex].rectangles.find(rect => rect.shapename === 'left_corner');
    if (!currentWallBaseLeftCorner) {currentWallBaseLeftCorner = {}}
    console.log(currentWallBaseLeftCorner);
    */

    if (mode===0) {
      newWall.id = Date.now().toString();
      newWall.wallx = wallx;
      newWall.wally = wally;         
      newWall.rectangles = [leftcorner,rightcorner];
      newWall.wallrectangles = [wallleftcorner, wallrightcorner];
      
      let collisionDetected = false;        
      for (const rect of newWall.rectangles) {
        collisionDetected = checkCollision(rect,newWall.wallrectangles);
        if (collisionDetected) {
          break;
        }
      }
      
      if (collisionDetected) {
        return false;
      };

      let adjBaseCorner, adjWallCorner;
      let heightAdjBaseCorner, heightAdjWallCorner;
      let yAdjBaseCorner, yAdjWallCorner;

      if (side === 'right') {
        if (currentWallIndex === walls.length - 1) {
          adjBaseCorner = walls[currentWallIndex].rectangles.find(rect => rect.shapename === "right_corner");
          heightAdjBaseCorner = adjBaseCorner?adjBaseCorner.height:6*34.5;
          yAdjBaseCorner = adjBaseCorner.y;

          adjWallCorner = walls[currentWallIndex].wallrectangles.find(rect => rect.shapename === "right_corner");          
          heightAdjWallCorner = adjWallCorner?adjWallCorner.height:6*34.5;
          yAdjWallCorner = adjWallCorner.y;

          newWall.rectangles.find(rect => rect.shapename === "left_corner").height = heightAdjBaseCorner;
          newWall.rectangles.find(rect => rect.shapename === "left_corner").y = yAdjBaseCorner;
          //newWall.rectangles.find(rect => rect.shapename === "left_corner").cabinetConfig = adjBaseCorner.cabinetConfig;

          newWall.wallrectangles.find(rect => rect.shapename === "left_corner").height = heightAdjWallCorner;
          newWall.wallrectangles.find(rect => rect.shapename === "left_corner").y = yAdjWallCorner;
          //newWall.wallrectangles.find(rect => rect.shapename === "left_corner").cabinetConfig = adjWallCorner.cabinetConfig;

          setWalls(prevWalls => [...prevWalls, newWall]);

        }
        else {
          setShowsuccess(false);
          setSuccmessage("");
          setShowerror(true);
          setErrmessage("There already exists a wall at the right of the current wall.");
          return false;
        }
      }
      else if (side === 'left') {
        if (currentWallIndex === 0) {

          adjBaseCorner = walls[currentWallIndex].rectangles.find(rect => rect.shapename === "left_corner");
          heightAdjBaseCorner = adjBaseCorner?adjBaseCorner.height:6*34.5;
          yAdjBaseCorner = adjBaseCorner.y;

          adjWallCorner = walls[currentWallIndex].wallrectangles.find(rect => rect.shapename === "left_corner");          
          heightAdjWallCorner = adjWallCorner?adjWallCorner.height:6*34.5;
          yAdjWallCorner = adjWallCorner.y;

          newWall.rectangles.find(rect => rect.shapename === "right_corner").height = heightAdjBaseCorner;
          newWall.rectangles.find(rect => rect.shapename === "right_corner").y = yAdjBaseCorner;
          //newWall.rectangles.find(rect => rect.shapename === "right_corner").cabinetConfig = adjBaseCorner.cabinetConfig;

          newWall.wallrectangles.find(rect => rect.shapename === "right_corner").height = heightAdjWallCorner;
          newWall.wallrectangles.find(rect => rect.shapename === "right_corner").y = yAdjWallCorner;
          //newWall.wallrectangles.find(rect => rect.shapename === "right_corner").cabinetConfig = adjWallCorner.cabinetConfig;

          setWalls(prevWalls => [newWall, ...prevWalls]);

          const newcurrentindex = currentWallIndex + 1;
          setCurrentWallIndex(newcurrentindex);
          setZeroIndex(zeroIndex + 1);
        }
        else {
          setShowsuccess(false);
          setSuccmessage("");
          setShowerror(true);
          setErrmessage("There already exists a wall at the left of the current wall.");      
          return false;
        }
      }
      return true;
    }
    else {      
      var baseCabinetsTotalCurrentWidth = 0;
      var wallCabinetsTotalCurrentWidth = 0;
  
      for (const item of newWall.rectangles) {
        if (item.shapename === "left_corner") {
          baseCabinetsTotalCurrentWidth += leftcorner.width;    
        }
        else if (item.shapename === "right_corner") {
          baseCabinetsTotalCurrentWidth += rightcorner.width;    
        }
        else {
          baseCabinetsTotalCurrentWidth += item.width;                
        }   
      } 
      
      for (const item of newWall.wallrectangles) {
        if (item.shapename === "left_corner") {
          wallCabinetsTotalCurrentWidth += wallleftcorner.width;    
        }
        else if (item.shapename === "right_corner") {
          wallCabinetsTotalCurrentWidth += wallrightcorner.width;    
        }
        else {
          wallCabinetsTotalCurrentWidth += item.width;                
        }   
      }         
      
      console.log("--------------");
      console.log(baseCabinetsTotalCurrentWidth);
      console.log(inchtopoint(initwall.wallwidth));
      console.log("--------------");
      
      if (baseCabinetsTotalCurrentWidth > inchtopoint(initwall.wallwidth)) {
        setSuccmessage("");
        setShowsuccess(false);
        setErrmessage("Not enough wall width for base cabinets.");
        setShowerror(true);
        return;
      }         

      if (wallCabinetsTotalCurrentWidth > inchtopoint(initwall.wallwidth)) {
        setSuccmessage("");
        setShowsuccess(false);
        setErrmessage("Not enough wall width for wall cabinets.");
        setShowerror(true);
        return;
      }         

      const leftCornerIndexToReplace = newWall.rectangles.findIndex(item => item.shapename === "left_corner");
      const rightCornerIndexToReplace = newWall.rectangles.findIndex(item => item.shapename === "right_corner");

      const wallleftCornerIndexToReplace = newWall.wallrectangles.findIndex(item => item.shapename === "left_corner");
      const wallrightCornerIndexToReplace = newWall.wallrectangles.findIndex(item => item.shapename === "right_corner");

      // for adjacent wall:
      /*
      if (newAdjacentLeftCorner) {
        const adjacentLeftCornerIndexToReplace = walls[currentWallIndex + 1].rectangles.findIndex(item => item.shapename === "left_corner");
      }      
      if (newAdjacentRightCorner) {
        const adjacentRightCornerIndexToReplace = walls[currentWallIndex + 1].rectangles.findIndex(item => item.shapename === "right_corner");
      }
      */
      


      let collisionDetected = false;

      // we are now checking for collisions before updating the wall
      // it checks for collisions using the position of the cabinets before applying the changes of the corners..
      // that will not detect collisions that may occur after the corners are updated and the other cabinets are shifted to the right..
      /*      
      for (const rect of [leftcorner,rightcorner, ...initwall.rectangles]) {
        collisionDetected = checkCollision(rect,[wallleftcorner, wallrightcorner, ...initwall.wallrectangles]);
        if (collisionDetected) {
          break;
        }
      }      
      if (collisionDetected) {
        //setWalls([initialWall]);
        //setRectangles(initialWall.rectangles);
        console.log(initwall);
        console.log(newWall);
        return false;
      };
      */

      // this check for collision is intended to detect collisions that may occur after shifting the cabinets to the right
      // (after updating the corners)
      let baseLeftWidthDifference, wallLeftWidthDifference;      
      baseLeftWidthDifference = leftcorner.width - previousBaseLeftCornerWidth;
      wallLeftWidthDifference = wallleftcorner.width - previousWallLeftCornerWidth;
      
      const newRects = newWall.rectangles.map(item =>
        item.shapename === "left_corner"?           
          leftcorner
        :
        item.shapename === "right_corner"?
          rightcorner
        :
          {...item, x: item.x + baseLeftWidthDifference}
      );

      /*
      for (const rect of newRects) {
        collisionDetected = checkCollision(rect,[wallleftcorner, wallrightcorner, ...initwall.wallrectangles]);
        if (collisionDetected) {
          return false;
        }
      } 
      */ 
      
      const newWallRects = newWall.wallrectangles.map(item =>
        item.shapename === "left_corner"?           
          wallleftcorner
        :
        item.shapename === "right_corner"?
          wallrightcorner
        :
          {...item, x: item.x + wallLeftWidthDifference}
      );
      
      for (const rect of newWallRects) {
        collisionDetected = checkCollision(rect,newRects);
        if (collisionDetected) {
          return false;
        }
      }  

      newWall.rectangles.splice(leftCornerIndexToReplace, 1, leftcorner);
      newWall.rectangles.splice(rightCornerIndexToReplace, 1, rightcorner);
      let tallHeight;
      let tallY;
      let leftCornerHeight, rightCornerHeight;
      let wallLeftCornerHeight, wallRightCornerHeight;
      let leftCornerY, rightCornerY;            
      let leftWallCornerY, rightWallCornerY;            
      
      newWall.rectangles.map(rect => {
        if (rect.cabinettype === "tall_cabinet") {
          tallY = inchtopoint(initwall.wallsoftheight) + wally;
          //tallHeight = rect.height - diffHeightWithSoftHeight;
          tallHeight = newWall.wallheight-initwall.wallsoftheight>0?inchtopoint(newWall.wallheight - initwall.wallsoftheight):rect.height;
          //rect.y = tallY;
          //rect.y = inchtopoint(initwall.wallheight)+wally-rect.height;
          rect.height = tallHeight;
        } 
        else {
          rect.y = inchtopoint(initwall.wallheight)+wally-rect.height;
          if (rect.shapename === "left_corner") {
            leftCornerHeight = rect.height;
            leftCornerY = inchtopointfactor*newWall.wallheight + wally - leftCornerHeight;    
            leftWallCornerY = wally + inchtopoint(initwall.wallsoftheight);
          }
          else if (rect.shapename === "right_corner") {
            rightCornerHeight = rect.height;
            rightCornerY = inchtopointfactor*newWall.wallheight + wally - rightCornerHeight;    
            rightWallCornerY = wally + inchtopoint(initwall.wallsoftheight);
          }

        }        
      });         

      newWall.wallrectangles.splice(wallleftCornerIndexToReplace, 1, wallleftcorner);
      newWall.wallrectangles.splice(wallrightCornerIndexToReplace, 1, wallrightcorner);
      newWall.wallrectangles.map(rect => {
        rect.y = wally + inchtopoint(initwall.wallsoftheight);
        if (rect.shapename === "left_corner") {
          wallLeftCornerHeight = rect.height;
        }
        else if (rect.shapename === "right_corner") {
          wallRightCornerHeight = rect.height;
        }
      });  
      
      // we were checking for collisions here but we will do it before

      
      console.log(newWall);
      /*
      setWalls(prevItems => {
        const updated = [...prevItems]; // clone the array
        updated[currentWallIndex] = newWall;       // replace the item at the given index
        return updated;
      });
      */    

      //console.log(leftcorner.width);
      //console.log(previousBaseLeftCornerWidth);

      setWalls(prevWalls =>
        prevWalls.map((wall, iwall) =>
          parseInt(iwall) === parseInt(currentWallIndex)? 
            { ...newWall, 
              rectangles: newWall.rectangles.map((rectangle, ri) => {
                if (ri > 0 && rectangle.shapename !== "right_corner") {
                  if (rectangle.cabinettype==="tall_cabinet") {
                    return {... rectangle, x:rectangle.x + baseLeftWidthDifference, y:inchtopoint(initwall.wallsoftheight)+wally, height: tallHeight? tallHeight:rectangle.height}
                  }
                  else {
                    return {... rectangle, x:rectangle.x + baseLeftWidthDifference}
                  }
                }
                else {
                  return rectangle;
                }            
              }),
              wallrectangles: newWall.wallrectangles.map((rectangle, ri) => {
                if (ri > 0 && rectangle.shapename !== "right_corner") {
                  return {... rectangle, x:rectangle.x + wallLeftWidthDifference}
                }
                else {
                  return rectangle;
                }            
              })              
            } 
            :parseInt(iwall) + 1 === parseInt(currentWallIndex)?
            { ...wall, 
              rectangles: wall.rectangles.map((rectangle, ri) => {
                if (rectangle.shapename === "right_corner") {
                  leftCornerY = inchtopointfactor*wall.wallheight + wally - leftCornerHeight;
                  if (newAdjacentRightCorner) {
                    return {...rectangle, 
                      cabinetConfig: newAdjacentRightCorner.configid,    
                      width: (newAdjacentRightCorner.widthMin)*inchtopointfactor,      
                      height:leftCornerHeight, 
                      cornerside: "R",
                      x:inchtopointfactor*wall.wallwidth + wallx  - (newAdjacentRightCorner.widthMin)*inchtopointfactor,
                      y:leftCornerY
                    }
                  }
                  else {                    
                    return {... rectangle, height:leftCornerHeight, y:leftCornerY}
                  }                                                    
                }
                else {
                  return rectangle;
                }            
              }),
              wallrectangles: wall.wallrectangles.map((rectangle, ri) => {
                if (rectangle.shapename === "right_corner") {
                  leftWallCornerY = wally + inchtopoint(wall.wallsoftheight);
                  if (newAdjacentWallRightCorner) {
                    return {...rectangle, 
                      cabinetConfig: newAdjacentWallRightCorner.configid,    
                      width: (newAdjacentWallRightCorner.widthMin)*inchtopointfactor,      
                      height:wallLeftCornerHeight, 
                      cornerside: "R",
                      x:inchtopointfactor*wall.wallwidth + wallx  - (newAdjacentWallRightCorner.widthMin)*inchtopointfactor,
                      y:leftWallCornerY
                    }
                  }
                  else {                    
                    return {... rectangle, height:wallLeftCornerHeight, y:leftWallCornerY}
                  }  

                  //return {... rectangle, height:wallLeftCornerHeight}
                }
                else {
                  return rectangle;
                }           
              })              
            }  
            :parseInt(iwall) - 1 === parseInt(currentWallIndex)?
            { ...wall, 
              rectangles: wall.rectangles.map((rectangle, ri) => {
                if (rectangle.shapename === "left_corner") {
                  rightCornerY = inchtopointfactor*wall.wallheight + wally - rightCornerHeight;
                  if (newAdjacentLeftCorner) {
                    return {...rectangle, 
                      cabinetConfig: newAdjacentLeftCorner.configid,  
                      width: (newAdjacentLeftCorner.widthMin)*inchtopointfactor,       
                      height:rightCornerHeight, 
                      cornerside: "L",
                      y:rightCornerY
                    }
                  }
                  else {                    
                    return {... rectangle, height:rightCornerHeight, y:rightCornerY}
                  }

                }
                else {
                  return rectangle;
                }            
              }),
              wallrectangles: wall.wallrectangles.map((rectangle, ri) => {
                if (rectangle.shapename === "left_corner") {
                  rightWallCornerY = wally + inchtopoint(wall.wallsoftheight);
                  if (newAdjacentWallLeftCorner) {
                    return {...rectangle, 
                      cabinetConfig: newAdjacentWallLeftCorner.configid,  
                      width: (newAdjacentWallLeftCorner.widthMin)*inchtopointfactor,       
                      height:wallRightCornerHeight, 
                      cornerside: "L",
                      y:rightWallCornerY
                    }
                  }
                  else {                    
                    return {... rectangle, height:wallRightCornerHeight, y:rightWallCornerY}
                  }
                }
                else {
                  return rectangle;
                }           
              })              
            }                             
            : wall
        )
      );     

      const prevLeftCorner = rectangles.find(rect => rect.shapename === "left_corner");
      const prevWallLeftCorner = wallrectangles.find(rect => rect.shapename === "left_corner");
      
      console.log(leftcorner);
      
      setRectangles(prevItems => prevItems.map(item =>
        item.shapename === "left_corner"?           
          leftcorner
        :
        item.shapename === "right_corner"?
          rightcorner
        :
          {...item, 
            //x: item.x - (prevLeftCorner.width - leftcorner.width), 
            x: item.x + baseLeftWidthDifference,
            height: item.cabinettype==="tall_cabinet"?(tallHeight? tallHeight:item.height):item.height,
            //y:inchtopoint(initwall.wallheight)+wally-item.height, 
            y: item.cabinettype==="tall_cabinet"?(tallY? tallY:item.y):inchtopoint(initwall.wallheight)+wally-item.height
          }
          //y = inchtopoint(walls[currentWallIndex].wallheight) + wally - height;                
          
      ));

      console.log(wallLeftWidthDifference);

      setWallRectangles(prevItems => prevItems.map(item =>
        item.shapename === "left_corner"?           
          wallleftcorner
        :
        item.shapename === "right_corner"?
          wallrightcorner
        :
          {...item, 
            x: item.x + wallLeftWidthDifference,
            y: wally + inchtopoint(initwall.wallsoftheight)
          }
      ));  
      
      
      return true;
    }
  }

  useEffect (() => {
    if (idselected === null) {
      switch(cabinettype) {
        case "base_cabinet":
          setCabinetHeight(34.5);
          setCabinetWidth(cabinetConfig.widthMin?cabinetConfig.widthMin:(cabinetConfig.initialWidth?cabinetConfig.initialWidth:12));
          break;
        case "wall_cabinet":
          setCabinetHeight(cabinetConfig.allowedHeights?cabinetConfig.allowedHeights[0]:(cabinetConfig.initialHeight?cabinetConfig.initialHeight:92));
          setCabinetWidth(cabinetConfig.widthMin?cabinetConfig.widthMin:(cabinetConfig.initialWidth?cabinetConfig.initialWidth:12));
          break;
        case "tall_cabinet":
          setCabinetWidth(cabinetConfig.widthMin?cabinetConfig.widthMin:(cabinetConfig.initialWidth?cabinetConfig.initialWidth:24));
          setCabinetHeight(cabinetConfig.allowedHeights?cabinetConfig.allowedHeights[0]:(cabinetConfig.initialHeight?cabinetConfig.initialHeight:92));
          break;
        case "appliances":
          setCabinetWidth(cabinetConfig.widthMin?cabinetConfig.widthMin:(cabinetConfig.initialWidth?cabinetConfig.initialWidth:12));
          setCabinetHeight(cabinetConfig.allowedHeights?cabinetConfig.allowedHeights[0]:(cabinetConfig.initialHeight?cabinetConfig.initialHeight:34.5));
          break;          
        default:
          setCabinetHeight(34.5);
          setCabinetWidth(12);
      }      
    }
    else {
      const handleKeyDown = (event) => {
        if (event.key === 'Delete') {
          // Run your delete function here
          try {
            console.log(idselected);
            onDeleteCabinet();
          }
          catch (e) {
            console.log(e);
          }
          
        }
      };

      // Add event listener on mount
      document.addEventListener('keydown', handleKeyDown);

      // Clean up event listener on unmount
      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };      
      /*
      const tallPlaceHolder = walls[currentWallIndex].wallrectangles.find(rect => rect.id === idselected); 
      if (tallPlaceHolder) {
        if (tallPlaceHolder.forTallCabinetId)  {
          console.log(tallPlaceHolder);
          onCabinetSelected({target:{getLayer:()=>{return {attrs:{id:idselected,selected:false,cabinettype:'wall_cabinet',cabinetConfig:tallPlaceHolder.configid},children:[{attrs:{width:tallPlaceHolder.width,height:tallPlaceHolder.height}}]}}}});
          setTimeout(() => {
            console.log(cabinettype);  
            //onDeleteCabinet();
          }, 3000);          
        }
      }
      */
    }
  }, [idselected]);

  useEffect(() => {
    if (shouldDelete) {
      /*
      console.log("It should match with the id of the placeholder:");
      console.log("Cabinet to delete: " + idselected);
      console.log(cabinettype);
      */
      onDeleteCabinet();      
      setShouldDelete(false);
    }
  }, [shouldDelete]);

  useEffect (() => {
    if (!idselected) {
      setCabinetWidth(cabinetConfig.widthMin?cabinetConfig.widthMin:(cabinetConfig.initialWidth?cabinetConfig.initialWidth:12));
      setCabinetHeight(
        cabinetConfig.allowedHeights?
          cabinetConfig.allowedHeights[0]
        :
          (cabinetConfig.initialHeight?
            cabinetConfig.initialHeight
          :
            cabinettype==="base_cabinet"?
              34.5
            :
              cabinettype==="wall_cabinet"?
                36
              :
                93
          )
      );
    }
  }, [cabinetConfig]); 

  useEffect (() => {
    setCabinetConfigOptions(cabinetConfigs.filter(cabconfig => cabconfig.cabtype === cabinettype));
    setCabinetConfig({});
    if (location.state) {
      //setCurrentWallIndex(0); 
      setCurrentWallIndex(location.state?location.state.zeroIndexWall:0);
      // setZeroIndex(0); // we need to set zeroIndex here, but how do we recognize which wall is the initial wall when the design was previously saved?
      //setZeroIndex(location.state?location.state.walls.findIndex(wall => wall.walldirection === 0):0); it will fail in certain room configs
      setZeroIndex(location.state?location.state.zeroIndexWall:0);
      setRectangles(location.state.walls[0].rectangles);
      setWallRectangles(location.state.walls[0].wallrectangles);
      
      console.log(location.state);

      FastQuotingCabinetVersionsDataService.findById(location.state.fastquotingcabinetversionId)
      .then(resp => {
        console.log(resp.data);
        setFinishCabinet(resp.data.finishcabinet);
        setFinishCabinetDoor(resp.data.finishcabinetdoor);

        setJobName(resp.data.fastquotingcabinet.job.jobtitle);
        setJobAddress(resp.data.fastquotingcabinet.job.jobaddress);
        setDuedate(new Date(dtFormatter(resp.data.fastquotingcabinet.job.jobduedate,3)).valueOf());        
      })
      .catch(err => {
        console.log(err);
        setShowerror(true);
        setErrmessage("An error occurred while retrieving cabinet quotes.");
      });
      
    }  
  }, []); 

  useEffect(() => {

  }, []);  

  useEffect (() => {
    setCabinetConfigOptions(cabinetConfigs.filter(cabconfig => cabconfig.cabtype === cabinettype));
    if (idselected) {

    }
    else {
      setCabinetConfig({});
    }
  }, [cabinettype]);

  /*
  useEffect(() => {
    if (currentWallIndex === 0 ) { // first wall
      setLeftSideWallRect({});
      if (currentWallIndex === walls.length - 1) { // last wall  
        console.log("first and last");
        setRightSideWallRect({});
      }
      else {
        console.log("first but not last");
        setRightSideWallRect({
          side: 'right'          
        });        
      }
    }
    else {
        // no to in the first but may be in the last wall
    }
    
  },[currentWallIndex]); // it will not change when a right wall is inserted
  */

  useEffect(() => {
    console.log("Current wall index changed to:" + currentWallIndex);
    setRectangles(walls[currentWallIndex].rectangles);
    setWallRectangles(walls[currentWallIndex].wallrectangles);
  },[currentWallIndex]);


  const handleSaveVersion = async (fastquotingcabinetId, mode, 
    baseCabinets, wallCabinets, tallCabinets,
    baseDoorPanels, WallDoorPanels, TallDoorPanels,
    numDrawers, finishcabinet,finishcabinetdoor
  ) => {
    var versionnumber = 1;
    FastQuotingCabinetVersionsDataService.getAll(fastquotingcabinetId) 
    .then(firstresponse => {
      versionnumber = firstresponse.data.length+1;
      console.log(versionnumber);

      var data = {
        fastquotingcabinetId: fastquotingcabinetId,
        userId: currentUser.id,
        comments: specialnotes,
        finishcabinet: finishcabinet, //finishcabinet.id
        finishcabinetdoor: finishcabinetdoor, //finishcabinetdoor.id
        baseCabinets:baseCabinets,
        wallCabinets:wallCabinets,  
        tallCabinets:tallCabinets,  
        finishEndsBaseCabinets: baseDoorPanels, //finishEndsBaseCabinets,
        finishEndsWallCabinets: WallDoorPanels, //finishEndsWallCabinets,
        finishEndsTallCabinets:TallDoorPanels, //finishEndsTallCabinets,
        islandsPanels: 0, //slandPanels,
        drawers: numDrawers, //drawers,
        toeKicksEtc: true, //toeKicksEtc,
        faceFrame: true, //faceFrame,
        installation: false, //installation,
        delivery: false, //delivery,
        distance:0, //distance,
        //versionnumber: versionnumber,
      }

      console.log(data);
      if (!location.state || saveAsNew) { // create
        data.versionnumber = versionnumber;
        
        FastQuotingCabinetVersionsDataService.create(data)
        .then(response => {          
          const newfastquoteversionid = response.data.calcs.versionid;
          console.log("response.data.calcs from fastquotecabinetversions:");
          console.log(response.data.calcs);        
          // finally, create the kitchendesign
          let kitchendesign = {
            userId: currentUser.id,
            kitchenfastquotestatus: 1,
            specialnotes: specialnotes,
            walls: walls,
            zeroIndexWall: zeroIndex,
          };
          kitchenfastquoteService.create(kitchendesign)
          .then(response => {
            const newkitchendesignid = response.data.id;
            var dataupdate = {
              kitchenfastquotenumber: 'KFQ-' + newkitchendesignid.toString().padStart(5,'0'),
              fastquotingcabinetversionId:newfastquoteversionid
            };
            kitchenfastquoteService.update(newkitchendesignid, dataupdate)          
            .then(() => {
              setShowsuccess(true);
              setSuccmessage('Fast Quoting Cabinet has been created successfully.');
              setShowerror(false);
              setErrmessage('');  
              window.location.assign(`/viewuserprofile/${currentUser.id}`);  
            })
            .catch((err) => {
              console.log(err);
              setShowsuccess(false);
              setSuccmessage("");
              setShowerror(true);
              setErrmessage(err);
            })        
          })
          .catch(err => {
            console.log(err.response.status);
            if (err.response.status===401) { // most likely the token expired
              window.location.assign('/login');
            }
          });              
        })  
        .catch(e => {
          setShowsuccess(false);
          setSuccmessage('');
          setShowerror(true);
          setErrmessage(e.response?e.response.data.message:e.message);                  
        })       
      }
      else {
        // copy parameters of this quote
        // this is not needed
        // parameters of the quote will be edited in the other page
        /*
        var data_params = {
          assemblycostbasewallcost: assemblycostbasewallcost,
          assemblycosttallcost: assemblycosttallcost,
          hardwarehingesbasewallcost: hardwarehingesbasewallcost,
          hardwarehingestallcost: hardwarehingestallcost,
          routingcost:routingcost,
          routingcostcasesqftbase:routingcostcasesqftbase,
          routingcostcasesqftwall:routingcostcasesqftwall,
          routingcostcasesqfttall: routingcostcasesqfttall,
          routingcostbacksqftbase:routingcostbacksqftbase,
          routingcostbacksqftwall:routingcostbacksqftwall,
          routingcostbacksqfttall:routingcostbacksqfttall,
          routingcostdoorssqftbase:routingcostdoorssqftbase,
          routingcostdoorssqftwall:routingcostdoorssqftwall,
          routingcostdoorssqfttall:routingcostdoorssqfttall,
          routingcostfinishendssqftbase:routingcostfinishendssqftbase,
          routingcostfinishendssqftwall:routingcostfinishendssqftwall,
          routingcostfinishendssqfttall:routingcostfinishendssqfttall,
          materialcostcasemarkup: materialcostcasemarkup,
          materialcostbackmarkup: materialcostbackmarkup,
          materialcostdoorsmarkup: materialcostdoorsmarkup,
          materialcostfinishendsmarkup: materialcostfinishendsmarkup,

          ebcostcasebase: ebcostcasebase,
          ebcostcasewall: ebcostcasewall,
          ebcostcasetall: ebcostcasetall,
          ebcostcasemarkup: ebcostcasemarkup,

          ebcostdoorsbase: ebcostdoorsbase,
          ebcostdoorswall: ebcostdoorswall,
          ebcostdoorstall: ebcostdoorstall,
          ebcostdoorsmarkup: ebcostdoorsmarkup,        
          
          drawercostdrawer: drawercostdrawer,
          drawercosthardware: drawercosthardware,
          drawercostmarkup: drawercostmarkup,

          faceframemarkup: faceframemarkup,
          basicdeliverycost40cab: basicdeliverycost40cab,
          unknownfactor: unknownfactor,
        }
        Object.assign(data, data_params);
        console.log(data);
        */
        console.log("update design");
        console.log(data);

        FastQuotingCabinetVersionsDataService.update(location.state.fastquotingcabinetversionId, data)
        .then(response => {          
          //console.log(response.data.calcs);
          // save edition of the design

          
          let kitchendesign = {
            kitchenfastquotestatus: 1,
            specialnotes: specialnotes,
            walls: walls,
            zeroIndexWall: zeroIndex,
          };
          kitchenfastquoteService.update(params.id,kitchendesign)
          .then(response => {
            setShowsuccess(true);
            setSuccmessage('Fast Quoting Cabinet has been created successfully.');
            setShowerror(false);
            setErrmessage('');  
            window.location.assign(`/viewuserprofile/${currentUser.id}`);  
          })
          .catch(err => {
            console.log(err.response.status);
            if (err.response.status===401) { // most likely the token expired
              window.location.assign('/login');
            }
          });                          
        })  
        .catch(e => {
          setShowsuccess(false);
          setSuccmessage('');
          setShowerror(true);
          setErrmessage(e.response?e.response.data.message:e.message);                  
        });      
      }


    })
    .catch(e => {
      console.log(e);
      setShowerror(true);
      setErrmessage(e.response?e.response.data.message:e.message);
      return;
    });

    //console.log(versionnumber);
    //return;

  }


  const onSaveDesign = () => {
    if (currentUser) {
      console.log(currentUser);

      // before creating anything, 
      // get the data that we will need for the fastquotecabinet and the fastquotecabinetversion
      // we will need for both, create and edit
      let base_cabinets = 0;
      let wall_cabinets = 0;
      let tall_cabinets = 0;
      let base_door_panels = 0;
      let wall_door_panels = 0;
      let tall_door_panels = 0;
      let numDrawers = 0;

      const cabslist = walls.map((wall, index) => { 
        base_cabinets += wall.rectangles.filter(rect => 
          !rect.cabinetConfig.includes("Adjacen") && 
          !rect.cabinetConfig.includes("placeholder") && 
          !rect.cabinetConfig.toLowerCase().includes("doorpanel") && 
          (rect.cabinettype === "base_cabinet")
        ).length;
        wall_cabinets += wall.wallrectangles.filter(rect => 
          !rect.cabinetConfig.includes("Adjacen") &&
          !rect.cabinetConfig.includes("placeholder") &&
          !rect.cabinetConfig.toLowerCase().includes("doorpanel") &&
          (rect.cabinettype === "wall_cabinet")
        ).length;      
        tall_cabinets += wall.rectangles.filter(rect => 
          !rect.cabinetConfig.includes("Adjacen") && 
          !rect.cabinetConfig.includes("placeholder") && 
          !rect.cabinetConfig.toLowerCase().includes("doorpanel") &&
          (rect.cabinettype === "tall_cabinet")
        ).length;                

        // number of door panels
        base_door_panels += wall.rectangles.filter(rect => 
          rect.cabinetConfig.toLowerCase().includes("doorpanel") && 
          (rect.cabinettype === "base_cabinet")
        ).length;
        wall_door_panels += wall.wallrectangles.filter(rect => 
          rect.cabinetConfig.toLowerCase().includes("doorpanel") &&
          (rect.cabinettype === "wall_cabinet")
        ).length;      
        tall_door_panels += wall.rectangles.filter(rect => 
          rect.cabinetConfig.toLowerCase().includes("doorpanel") &&
          (rect.cabinettype === "tall_cabinet")
        ).length;  

        // should we get the number of drawers as well?
        numDrawers += wall.rectangles.reduce((accumulator, currentValue) => {
          return accumulator + (currentValue.compDrawers?currentValue.compDrawers:0)+(currentValue.compRollouts?currentValue.compRollouts:0);
        }, 0); // The '0' is the initial value for the accumulator

        numDrawers += wall.wallrectangles.reduce((accumulator, currentValue) => {
          return accumulator + (currentValue.compDrawers?currentValue.compDrawers:0)+(currentValue.compRollouts?currentValue.compRollouts:0);
        }, 0); // The '0' is the initial value for the accumulator
      });

      if (base_cabinets === 0 && wall_cabinets ===0 && tall_cabinets === 0) {
        setSuccmessage("");
        setShowsuccess(false);
        setErrmessage("It looks like the current design doesn't have any cabinets. Please, add some cabinets to save the design.");
        setShowerror(true);
        return;
      }

      if (finishcabinet === null || finishcabinetdoor === null) {
        setSuccmessage("");
        setShowsuccess(false);
        setErrmessage("Please select a finish for both the cabinet and the door.");
        setShowerror(true);
        return;
      }

      if (!location.state) { // if no location.state, we assume it is a new design.
        console.log("new design");    
        // create job interview first
        var jobInterviewData = {
          userId: currentUser.id,
          jobtitle: jobname,
          jobdescription: jobname,
          jobaddress: jobaddress,
          jobduedate: duedate
        };
        JobInterviewDataService.create(jobInterviewData)
        .then(response => {
          console.log("Job interview created:", response.data);

          // first create the fastquotecabinet
          var data = {
            userId: currentUser.id,
            fastquotingcabinetstatus:1, 
            specialnotes:specialnotes,
            jobId: response.data.id,     
          };
          FastQuotingCabinetDataService.create(data)      
          .then(response => {  
            const newfastquotecabinetid = response.data.id;
            var dataupdate = {
              fastquotingcabinetnumber: 'FQCab-' + newfastquotecabinetid.toString().padStart(5,'0')
            };
            FastQuotingCabinetDataService.update(newfastquotecabinetid, dataupdate)          
            .then(() => {
              // then create the fastquotecabinetversion
              handleSaveVersion(response.data.id, location.state?1:0, 
                base_cabinets, wall_cabinets, tall_cabinets,
                base_door_panels, wall_door_panels, tall_door_panels,
                numDrawers,finishcabinet,finishcabinetdoor
              ); 

              //window.location.assign(`/viewuserprofile/${currentUser.id}`)       
            })
            .catch((err) => {
              setErrmessage(err.response?err.response.data.message:err.message);
              setShowerror(true);
              console.log(err);
            })          
          })      
          .catch(e => {
            
            console.log(e);        
            setShowsuccess(false);
            setSuccmessage('');
            setShowerror(true);
            setErrmessage(e.response?e.response.data.message:e.message)        
            //console.log(e.response.status === 401);
            if (e.response.status === 401) {
              window.location.assign("/login");
            }
          }); 



        })
        .catch(error => {
          console.error("Error creating job interview:", error);
          setShowsuccess(false);
          setSuccmessage('');
          setShowerror(true);
          setErrmessage(error.response?error.response.data.message:error.message);
        });
      }
      else {
        console.log("existing design");   
        
        FastQuotingCabinetVersionsDataService.findById(location.state.fastquotingcabinetversionId)
        .then(resp => {        
          console.log(resp.data);
          const jobid = resp.data.fastquotingcabinet.job.id;
          JobInterviewDataService.update(jobid, {
            jobtitle: jobname,
            jobdescription: jobname,
            jobaddress: jobaddress,
            jobduedate: duedate
          })
          .then(() => {
            console.log("Job interview updated");
            // then create the fastquotecabinetversion
            handleSaveVersion(location.state.fastquotingcabinetId, 
              1, base_cabinets, wall_cabinets, tall_cabinets,
              base_door_panels, wall_door_panels, tall_door_panels,
              numDrawers,finishcabinet,finishcabinetdoor
            );                   
          })
          .catch(error => {
            console.error("Error updating job interview:", error);
            setShowsuccess(false);
            setSuccmessage('');
            setShowerror(true);
            setErrmessage(error.response?error.response.data.message:error.message);
          });          
        });
      }
    }
    else {
      setShowsuccess(false);
      setSuccmessage("");
      setShowerror(true);
      setErrmessage("You must be logged in to save your design.");
    }
    
  };

  

  return (
    <>      
      {/** not right now, may be later
      <Toast show={show} onClose={toggleShow} delay={3000} autohide position={"bottom-end"}>
        <Toast.Header>
          <strong className="me-auto">Notification</strong>
          <small>Just now</small>
        </Toast.Header>
        <Toast.Body>This is a simple toast message.</Toast.Body>
      </Toast>    
      */}


      <div style={{display:"flex", flexDirection:"column",width:"100%"}}>
        <TopAndSideBar />
        <NewHeader headerTitle={(!location.state?"New Kitchen Fast Quote":"Edit Kitchen Fast Quote")}/>
          <Alert>
              Start designing today! Follow our <Alert.Link target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/watch?v=0zBnjCi6Cck&list=PLupMpToVwrg-vdMf0ARBkvgfP6RlJ7VeX&index=5">tutorial videos</Alert.Link> to master the Online Configurator.
          </Alert>
        <div style={{padding:"0 8vw",}}>
          {/*<PageHeader />*/}          

          <div style={{height:'100%', display:'flex',flexDirection:'row',flexWrap:'wrap',alignContent:'flex-start'}}>
            <Col>
              <Row>
                <Col style={{maxWidth:'150px'}}>
                  <span>
                    Job Interview
                  </span>        

                  <KitchenQuoteJobInterview 
                    jobname={jobname}
                    jobaddress={jobaddress}
                    duedate={duedate}
                    finishcabinets={finishcabinets}
                    finishcabinetdoors={finishcabinetdoors}
                    finishcabinet={finishcabinet}
                    finishcabinetdoor={finishcabinetdoor}
                    defaultbackfinish={defaultbackfinish}
                    onChangeFinishCabinet={onChangeFinishCabinet}
                    onChangeFinishCabinetDoor={onChangeFinishCabinetDoor}
                    onChangeJobName={onChangeJobName}
                    onChangeJobAddress={onChangeJobAddress}
                    onChangeDueDate={onChangeDueDate}
                    retrieveFinishCabinets={retrieveFinishCabinets}
                    retrieveFinishCabinetDoors={retrieveFinishCabinetDoors}
                    retrieveVersionDataForJobInterview={retrieveVersionDataForJobInterview}

                  />             

                </Col>              


                <Col style={{maxWidth:'400px',margin:0,padding:0}}>
                  <span>
                    Wall Config
                  </span>     

                  <Row>
                    <Row className='row-sm-4' style={{textAlign:'center'}}>
                      <Col style={{textAlign:'left',maxWidth:'750px'}}>
                        <Row>
                          <InsertOrEditCurrentWall 
                            walls={[...walls]}
                            wall={{...walls[currentWallIndex]}}
                            mode={0} 
                            currentWallIndex={currentWallIndex} 
                            totalwalls={walls.length} 
                            sumOfAngles={sumOfAngles} 
                            zeroIndex={zeroIndex} // why was this being passed as 0?
                            onInsertWall={onInsertWall}
                            onInsertCabinet={onInsertCabinet}
                            onDeleteWall={onDeleteWall}
                          />           
                          <InsertOrEditCurrentWall 
                            walls={[...walls]}
                            wall={{...walls[currentWallIndex]}} 
                            mode={1}
                            currentWallIndex={currentWallIndex} 
                            totalwalls={walls.length} 
                            sumOfAngles={sumOfAngles} 
                            zeroIndex={zeroIndex} // why was this being passed as 0?  // IT happens when opening a previously saved design // this is affecting the dropdown of corners, they are not being disabled as needed
                            onInsertWall={onInsertWall} 
                            onInsertCabinet={onInsertCabinet} 
                            onDeleteWall={onDeleteWall}                                      
                          /> 
                        </Row>
                        <FormLabel htmlFor="raisedby" >{"Total Walls: " + walls.length}</FormLabel>
                      </Col>


                      <Col className='col-sm-4' style={{textAlign:'center'}}>
                        <Container style={{display:'flex',justifyContent:'center', gap:5}}>
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={moveleftWallTooltip}>        
                            <Button id="insert-left-wall" onClick={onMoveToLeftWall}>
                              <FaArrowCircleLeft />
                            </Button> 
                          </OverlayTrigger>  

                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={moverightWallTooltip}>        
                            <Button id="insert-right-wall" onClick={onMoveToRightWall}>
                              <FaArrowCircleRight />                    
                            </Button> 
                          </OverlayTrigger>   

                        </Container>
                        <FormLabel htmlFor="raisedby" >Move to Wall:</FormLabel>                        
                      </Col>  
                      

                    </Row>
                  </Row>
                </Col>          
              </Row>

              <Row>
                <Col style={{display:'flex',flexDirection:'column',justifyContent:'left',alignItems:'left'}}>
                  <RectanglesVisualizer 
                    walls={walls}
                    currentWallIndex={currentWallIndex}
                  />
                </Col>   

              </Row>

              <Row>
                <Col style={{maxWidth:"600px"}}>                
                  <Row>
                    <h6 className='mt-4'>
                      {idselected?"Edit selected cabinet":"Insert cabinet"}
                    </h6>              
                    <Col style={{maxWidth:"550px"}}>
                    
                      <Row>

                        <Col>
                          <Row>
                            <Col >
                              <FormLabel className="mr-5">Cabinet Type:</FormLabel>
                              <select 
                                defaultValue={0} 
                                className="form-control" 
                                id="cabinet-type" 
                                name="cabinet-type" 
                                onChange={onChangeCabinetType}
                                disabled={idselected !== null}
                              >
                                <option value={"base_cabinet"} selected={cabinettype==="base_cabinet"}>{"Base Cabinet"}</option>
                                <option value={"tall_cabinet"} selected={cabinettype==="tall_cabinet"}>{"Tall Cabinet"}</option>
                                <option value={"wall_cabinet"} selected={cabinettype==="wall_cabinet"}>{"Upper Cabinet"}</option>
                                /*not really appliances*/
                                /*actual appliances are included as base cabinets */
                                <option value={"appliances"} selected={cabinettype==="appliances"}>{"Kitchen Elements"}</option>
                              </select> 
                            </Col>

                            <Col className='col-sm-6'>
                              <FormLabel className="mr-5">Cabinet Config:</FormLabel>
                              <select 
                                defaultValue={0} 
                                value={cabinetConfig.configid}
                                className="form-control" 
                                id="cabinet-config" 
                                name="cabinet-config" 
                                onChange={onChangeCabinetConfig}
                                disabled={idselected !== null && cabinetConfig.configid}
                              >
                              <ListOfCabinetConfigOptions 
                                cabinetConfigoptions={cabinetConfigoptions}
                                cabinetConfig={cabinetConfig}
                              />
                              </select> 
                            </Col>
                          </Row>
                        
                          <Row>
                            <Row className='col-sm-6'>

                              <Col className="col-sm-6">
                                <FormLabel className="mr-2" htmlFor="raisedby">Cab. Width:</FormLabel>
                                <FormControl className="form-control"
                                  style={{maxWidth:'90px'}}
                                  value={cabinetwidth} ////////////////////////////////////////////////////////////////////////////////
                                  onChange={onChangeCabinetWidth}
                                  disabled={cabinetConfig.configid==='B:PO-Wd1Dr-S' || cabinetConfig.configid==='B:PO-Wd1Dr-L'}
                                  type="number"
                                  name="cabinetwidth"
                                  id="cabinetwidth" />              
                              </Col>        

                              <Col className="col-sm-6">
                                <FormLabel className="mr-2" htmlFor="raisedby">Cab. Height:</FormLabel>
                                <FormControl className="form-control"
                                  style={{maxWidth:'90px'}}
                                  value={cabinetHeight} ////////////////////////////////////////////////////////////////////////////////
                                  onChange={onChangeCabinetHeight}
                                  disabled={cabinettype==='base_cabinet'}
                                  type="number"
                                  name="cabinetHeight"
                                  id="cabinetHeight" />              
                              </Col>                             
                            
                            </Row>                      

                            {(cabinetwidth < cabinetConfig.widthMin || cabinetwidth > cabinetConfig.widthMax) &&
                              <Col style={{display:'flex', justifyContent:'flex-start', alignItems:'flex-end',marginBottom:'5px',cursor:'pointer'}}>
                                <IoWarning size={27} color="#9C0006" onClick={showWidthStdDimensions}/>
                              </Col>                            
                            }          

                            {(cabinettype!="tall_cabinet" && cabinetConfig.allowedHeights && !cabinetConfig.allowedHeights.includes(cabinetHeight)) &&
                              <Col style={{display:'flex', justifyContent:'flex-start', alignItems:'flex-end',marginBottom:'5px',cursor:'pointer'}}>
                                <IoWarning size={27} color="#9C0006" onClick={showHeightStdDimensions}/>
                              </Col>                            
                            }                                   
                          </Row>                        
                        </Col>


                        <Col className='col-sm-2' style={{textAlign:'left'}}>
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={doubleClickToInsertTooltip}>        
                            <FormLabel>Preview:</FormLabel>
                          </OverlayTrigger>                            
                          
                          <Stage width={200} height={inchtopoint(34.5)/1.5}>
                            <Layer onDblClick={handleLayerDoubleClick} onDblTap={handleLayerDoubleClick}>
                              {(Object.keys(cabinetConfig).length>0) &&
                                <>
                                <cabinetConfig.configcomponentname
                                  rect={{
                                    id:"image",
                                    //width:(1.592307693)*(cabinetwidth>cabinetHeight?90:(cabinetwidth*130/cabinetHeight)),
                                    //height:(1.592307693)*(cabinetwidth<cabinetHeight?130:(cabinetHeight*90/cabinetwidth)),
                                    width:Math.round(100*(cabinetwidth>cabinetHeight?90:(cabinetwidth*130/cabinetHeight)))/100,
                                    height:Math.round(100*(cabinetwidth<cabinetHeight?130:(cabinetHeight*90/cabinetwidth)))/100,
                                    adjustDimsPar: true,
                                    selected:false,
                                    fill:cabinetColor,
                                    cabinettype:cabinettype,
                                    shapename:cabinettype,
                                    cabinetConfig: cabinetConfig.configname,
                                    side: cabinetConfig.side,
                                    hideTexts:true,
                                    numDrawersFronts: cabinetConfig.numDrawersFronts?cabinetConfig.numDrawersFronts:0,
                                    compDrawers: cabinetConfig.compDrawers?cabinetConfig.compDrawers:0,                                    
                                  }}                    
                                />   
                                </>                   
                              }                    
                            </Layer>
                          </Stage>
                        </Col>  
                        
                      </Row>                    


                      <div style={{display:'flex',flexDirection:'row',alignItems:'flex-end', justifyContent:'space-evenly',gap:'20px'}}>
                        <Col className='col-sm-4' style={{textAlign:'left', width:'20%'}}>
                          <Container style={{display:'flex',justifyContent:'left', gap:10, padding:0}}>
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={addElementToTheWall}>   
                              {/**
                              <Button onClick={() => {
                                const insertedCab = onInsertCabinet({cabinetConfig, cabinettype, cabinetwidth, cabinetHeight});
                                var automaticPlaceholderWallCabinet = {};
                                if (cabinettype === "tall_cabinet") {
                                  if (idselected) {
                                    automaticPlaceholderWallCabinet = wallrectangles.find(rect => rect.forTallCabinetId === idselected);
                                    if (automaticPlaceholderWallCabinet) {                                
                                      console.log(automaticPlaceholderWallCabinet);
                                      onCabinetSelected({target:{getLayer:()=>{return {attrs:{forTallCabinetId:automaticPlaceholderWallCabinet.forTallCabinetId,id:automaticPlaceholderWallCabinet.id,selected:false,cabinettype:'wall_cabinet',cabinetConfig:automaticPlaceholderWallCabinet.cabinetConfig},children:[{attrs:{width:automaticPlaceholderWallCabinet.width,height:automaticPlaceholderWallCabinet.height}}]}}}});                                          
                                    }
                                  }
                                  else {      
                                    automaticPlaceholderWallCabinet = AllCabinetConfigs.find(cabconfig => cabconfig.configid === "W:placeholder_for_tall_cabinets");                                  
                                    if (automaticPlaceholderWallCabinet) {                                
                                      automaticPlaceholderWallCabinet.forTallCabinetId = insertedCab.id;                                                                        
                                      onInsertCabinet({cabinetConfig: automaticPlaceholderWallCabinet, 
                                        cabinettype:"wall_cabinet", 
                                        cabinetwidth:cabinetwidth, cabinetHeight:1
                                      });                                      
                                    }
                                  }
                                }
                              }}>
                              */}
                              <Button onClick={() => {onInsertCabinet({cabinetConfig, cabinettype, cabinetwidth, cabinetHeight});}}>
                                {!idselected && <MdAddToPhotos color='white'/>}
                                {idselected && <IoSave color='white'/>}
                              </Button> 
                            </OverlayTrigger>  
          
                            {idselected && 
                              <OverlayTrigger
                                placement="bottom"
                                delay={{ show: 250, hide: 400 }}
                                overlay={deleteElementFromTheWall}>  
                                {/**
                                <Button 
                                  onClick={() => {
                                    const idselectedbeforedelete = idselected;
                                    // if it is a tall cabinet, we need to delete the placeholder wall cabinet as well
                                    if (cabinettype === "tall_cabinet") { 
                                      const blankCabinetToDelete = wallrectangles.find(rect => rect.forTallCabinetId === idselectedbeforedelete);
                                      if (blankCabinetToDelete) {
                                        console.log("The id of the placeholder: " + blankCabinetToDelete.id);
                                        onCabinetSelected({target:{getLayer:()=>{return {attrs:{forTallCabinetId:blankCabinetToDelete.forTallCabinetId,id:blankCabinetToDelete.id,selected:false,cabinettype:'wall_cabinet',cabinetConfig:blankCabinetToDelete.cabinetConfig},children:[{attrs:{width:blankCabinetToDelete.width,height:blankCabinetToDelete.height}}]}}}});
                                      }
                                  }}} 
                                  style={{backgroundColor:"#FFC7CE",borderStyle:"none"}}
                                >
                                */}     
                                <Button onClick={onDeleteCabinet} style={{backgroundColor:"#FFC7CE",borderStyle:"none"}}>
                                  <MdDelete  color="#9C0006" size={25}/>                 
                                </Button> 
                              </OverlayTrigger>                     
                            }
                          </Container>
                        </Col> 

                        <Col style={{textAlign:'left',marginRight:'20px'}}>
                            <Row>
                              <OverlayTrigger
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                              >        
                                <DetailKitchenCabinets 
                                  walls={walls}
                                />    
                              </OverlayTrigger>             
                            </Row>                    
                        </Col>    

                        <Col className='col-sm-4' style={{textAlign:'left',width:'30%'}}>
                          <Row className='mt-2' id="" style={{display:'flex', flexDirection:'row',alignContent:'flex-end'}}>
                            <Button disabled={currentWallIndex!==0} onClick={async () => {setModalVisible(true);await handleExportToPdf();setModalVisible(false);}} >Download!</Button>
                            <ProgressModal visible={isModalVisible}/>
                          </Row>                                                          
                        </Col>

                        <Col className='col-sm-4' style={{textAlign:'left',width:'30%'}}>
                          <KitchenFastQuoteSpecialNotes 
                            onChangeSpecialNotes={onChangeSpecialNotes}
                            specialnotes={specialnotes}
                            onSave={onSaveDesign}
                            saveAsNew={saveAsNew}
                            onChangeSaveAsNew={onChangeSaveAsNew}
                            locationstate={location.state}
                            user={currentUser}
                          />
                        </Col>                    
                      </div>  

                      {(currentUser && !currentUser.isVerified) &&
                      <ModalVerifyEmail 
                        sendVerifyEmail={sendVerifyEmail}
                        user={currentUser}  
                      />
                      }

                    </Col>                                 

                  </Row>
                </Col>

              </Row>            
            </Col>

            <Col style={{width:'75vw'}}>   
              {/* height doesn't affect in this row below */}
              <Row className='mt-2' id="testrowwidth" style={{width:'100%', display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                <FormLabel style={{textAlign:'left',marginLeft:'100px',textDecoration:'underline'}}>
                  {"You are viewing wall: "}
                  <strong style={{textDecoration:'underline'}}>
                    {walls[currentWallIndex].wallname.toUpperCase()}
                  </strong>
                </FormLabel>
              </Row>

              <Row style={{height:'100%'}}>

                <Stage width={inchtopoint(walls[currentWallIndex].wallwidth)+extracanvasx} height={inchtopoint(walls[currentWallIndex].wallheight)+extracanvasy} ref={stageRef}>
                  <Layer onMouseMove={mouseOverMainLayer} onMouseOut={mouseLeaveMainLayer}>

                    <Text text={walls[currentWallIndex].wallwidth + " in"} align="center" width={inchtopoint(walls[currentWallIndex].wallwidth)} /> 
                    <WallFrontalRect                    
                      width={inchtopoint(walls[currentWallIndex].wallwidth)}
                      height={inchtopoint(walls[currentWallIndex].wallheight)}
                      color={wallColor}
                    />
                    <Text 
                      rotation={-90}
                      text={walls[currentWallIndex].wallheight + " in"} 
                      align="center" 
                      width={40}
                      x={10} 
                      y={inchtopoint(walls[currentWallIndex].wallheight)/2}
                    /> 
                    {/* measure in Y tooltip */}
                    <Group x={0} y={0}>
                      <Arrow 
                        visible={ytooltipProp.visible}
                        x={ytooltipProp.x + 15}
                        y={ytooltipProp.yfrom}
                        points={[0, 0, 0, ytooltipProp.yto]}
                        pointerLength={10}
                        pointerWidth={10}
                        fill="black"
                        stroke="black"
                        strokeWidth={1}                    
                      />                    
                      <Rect
                        visible={ytooltipProp.visible}
                        width={70}
                        height={25}
                        x={ytooltipProp.x}
                        y={ytooltipProp.y}
                        fill="lightblue"
                        stroke="blue"
                        strokeWidth={1}
                        opacity={1}
                      />      
                      <Text
                        {...ytooltipProp}
                        fontFamily="Calibri"
                        fontSize={14}
                        padding={5}
                        fill="black"
                        opacity={1}
                      />
                    </Group>  

                    {/* measure in X tooltip */}
                    <Group x={0} y={0}>
                      <Arrow 
                        visible={xtooltipProp.visible}
                        x={0}
                        y={xtooltipProp.y + 13}
                        points={[xtooltipProp.xfrom, 0, xtooltipProp.xto, 0]}
                        pointerLength={10}
                        pointerWidth={10}
                        fill="black"
                        stroke="black"
                        strokeWidth={1}                    
                      />                    
                      <Rect
                        visible={xtooltipProp.visible}
                        width={70}
                        height={25}
                        x={xtooltipProp.x}
                        y={xtooltipProp.y}
                        fill="lightblue"
                        stroke="blue"
                        strokeWidth={1}
                        opacity={1}
                      />      
                      <Text
                        {...xtooltipProp}
                        fontFamily="Calibri"
                        fontSize={14}
                        padding={5}
                        fill="black"
                        opacity={1}
                      />
                    </Group>  

                  </Layer>

                  
                  {/* Cabinets added */}
                  {wallrectangles.map(rect => {
                    const ObjConfig = cabinetConfigs.find(cabconfig => cabconfig.configid === rect.cabinetConfig);
                    if (!ObjConfig) { 
                      return (
                      <>      
                      <Layer
                        x={rect.x}
                        y={rect.y}
                        width={rect.width}
                        height={rect.height}   
                        adjustDimsPar={false}        
                        id={rect.id} // unique ID
                        ref={(node) => (shapeRefs.current[rect.id] = node)}                                    
                        cabinettype={rect.cabinettype}    
                        cabinetConfig={rect.cabinetConfig}
                        selected={rect.selected}    

                        shapename={rect.shapename}    
                        
                        onClick={(e) => {
                          console.log("selected");
                          e.target.setAttr("opacity", 1);
                          //rect.selected = true;
                          onCabinetSelected(e);
                        }}                         
                      >
                        <Text
                          width={rect.width}
                          text={"Config not found: " + rect.cabinetConfig}
                          fontSize={14}
                          fill="red"
                        />                        
                        <Rect
                          width={rect.width}
                          height={rect.height}
                          stroke="red"
                          strokeWidth={1} 
                        />
                      </Layer>                                                  
                      </>
                      );
                    }
                    const Eleconfig = ObjConfig.configcomponentname;                
                    return (
                      <>      
                      <Layer
                        //draggable 
                        onDragStart={(e) => {dragStart(e,rect.id)}}
                        onDragEnd={(e) => dragEnd(e, rect.id)}                    
                        onDragMove={handleBoundingDropMove}                       
                        //dragBoundFunc={handleDragBound}
                        x={rect.x}
                        y={rect.y}
                        width={rect.width}
                        height={rect.height}   
                        adjustDimsPar={false}        
                        id={rect.id} // unique ID
                        ref={(node) => (shapeRefs.current[rect.id] = node)}                                    
                        cabinettype={rect.cabinettype}    
                        cabinetConfig={rect.cabinetConfig}
                        selected={rect.selected}    

                        shapename={rect.shapename}                      
                        forTallCabinetId={rect.forTallCabinetId}                      
                        
                        onClick={(e) => {
                          console.log("selected");
                          e.target.setAttr("opacity", 1);
                          //rect.selected = true;
                          onCabinetSelected(e);
                        }} 
                        onTap={(e) => {
                          console.log("selected");
                          e.target.setAttr("opacity", 1);
                          //rect.selected = true;
                          onCabinetSelected(e);
                        }}                      
                      >
                        {(Object.keys(ObjConfig).length>0) &&
                          < Eleconfig rect={{...rect,adjustDimsPar:false}}/>
                        }
                      </Layer>                                                  
                      </>
                    )                
                  })}              
                  
                  {rectangles.map(rect => {
                    const ObjConfig = cabinetConfigs.find(cabconfig => cabconfig.configid === rect.cabinetConfig);
                    if (!ObjConfig) { 
                      return (
                      <>      
                      <Layer
                        x={rect.x}
                        y={rect.y}
                        width={rect.width}
                        height={rect.height}   
                        adjustDimsPar={false}        
                        id={rect.id} // unique ID
                        ref={(node) => (shapeRefs.current[rect.id] = node)}                                    
                        cabinettype={rect.cabinettype}    
                        cabinetConfig={rect.cabinetConfig}
                        selected={rect.selected}    

                        shapename={rect.shapename}    
                        
                        onClick={(e) => {
                          console.log("selected");
                          e.target.setAttr("opacity", 1);
                          //rect.selected = true;
                          onCabinetSelected(e);
                        }}                         
                      >
                        <Text
                          width={rect.width}
                          text={"Config not found: " + rect.cabinetConfig}
                          fontSize={14}
                          fill="red"
                        />                        
                        <Rect
                          width={rect.width}
                          height={rect.height}
                          stroke="red"
                          strokeWidth={1}                       
                        />

                        
                      </Layer>                                                  
                      </>
                      );
                    }

                    const Eleconfig = ObjConfig.configcomponentname;                                  
                      
                    return (
                      <>                  
                      <Layer 
                        //draggable 
                        onDragStart={(e) => {dragStart(e, rect.id)}}
                        onDragEnd={(e) => dragEnd(e, rect.id)}  
                        onDragMove={handleBoundingDropMove}  
                        //dragBoundFunc={handleDragBound} 
                        x={rect.x}
                        y={rect.y}
                        width={rect.width}
                        
                        ////height={rect.height}                    
                        //height={rectHeightNoToekick}  
                        
                        adjustDimsPar={false}        

                        id={rect.id} // unique ID
                        ref={(node) => (shapeRefs.current[rect.id] = node)}                                                      
                        cabinettype={rect.cabinettype}   
                        cabinetConfig={rect.cabinetConfig}
                        shapename={rect.shapename}
                        
                        selected={rect.selected}

                        compDrawers={rect.compDrawers}
                        compRollouts={rect.compRollouts}

                        onClick={(e) => {
                          console.log("selected");
                          console.log(e.target);
                          e.target.setAttr("opacity", 1);
                          //rect.selected = true;
                          onCabinetSelected(e);
                        }}    
                        onTap={(e) => {
                          console.log("selected");
                          e.target.setAttr("opacity", 1);
                          //rect.selected = true;
                          onCabinetSelected(e);
                        }}     
                        
                        onMouseMove={(e) => {
                          e.target.setAttr("opacity", 1)
                          e.target.getStage().container().style.cursor = 'pointer';
                        }}                   
                        onMouseLeave={(e) => {
                          if (!rect.selected) {
                            e.target.setAttr("opacity", normalopacity);                          
                          }
                          e.target.getStage().container().style.cursor = 'default';
                        }}                           
                      >

                        {(Object.keys(ObjConfig).length>0) &&
                          < Eleconfig 
                            rect={{
                              ...rect, 
                              adjustDimsPar:false,
                              handleMouseEnter:handleMouseEnter,
                              handleMouseMove:handleMouseMove,
                              handleMouseLeave:handleMouseLeave                              
                            }}
                            tst={1}                            
                          />
                        }            
                      </Layer>                                                    
                      </>
                    )                
                  })}

                  <WrapWallLeftSideRect 
                    side = {'left'}
                    walls = {walls}
                    currentWallwidth = {walls[currentWallIndex].wallwidth}
                    currentWallHeight = {walls[currentWallIndex].wallheight}
                    currentWallx = {wallx}
                    currentWally = {wally}
                    currentWallIndex = {currentWallIndex}
                    color = {wallColor}              
                  />

                  <WrapWallRightSideRect 
                    side = {'right'}
                    walls = {walls}
                    currentWallwidth = {walls[currentWallIndex].wallwidth}
                    currentWallHeight = {walls[currentWallIndex].wallheight}
                    currentWallx = {wallx}
                    currentWally = {wally}
                    currentWallIndex = {currentWallIndex}                
                    color = {wallColor}              
                  />      

                  <Layer>
                  {tooltip.visible && (
    <>
    {/**
    <Rect
      key={rect.id}
      width={rect.width}
      height={rect.height}
      adjustDimsPar={rect.adjustDimsPar}

      onMouseMove={(e) => {
        //e.target.setAttr("opacity", 1)
        e.target.getStage().container().style.cursor = 'pointer';
        const mousePos = e.target.getStage().getPointerPosition();
        
        //const shownWidth = Math.round(100*(rect.width>rect.height?rect.height/90:rect.width/3.768115))/100; //(cabinetwidth>cabinetHeight?90:(cabinetwidth*130/cabinetHeight));
        //const shownHeight = Math.round(100*(rect.height>rect.width?rect.width/130:rect.height/3.768115))/100; //(cabinetwidth<cabinetHeight?130:(cabinetHeight*90/cabinetwidth));

        if (rect.adjustDimsPar) { // we are rendering the preview

        }
        else {
          setTooltipProp({
            fill: 'black',
            text: `${rect.cabinetConfig}\nW=${Math.round(100*rect.width/inchtopointfactor)/100}, H=${Math.round(100*rect.height/inchtopointfactor)/100}, D=${24}`,
            //text: `${JSON.stringify(rect.adjustDimsPar)}`,
            visible: true,
            x: mousePos.x - rect.x + 20, //mousePos.x - 90,
            y: mousePos.y - rect.y
          });     
        }       
      }}                   
      onMouseLeave={(e) => {
        if (!rect.selected) {
          e.target.setAttr("opacity", normalopacity);                          
        }
        e.target.getStage().container().style.cursor = 'default';                      
        setTooltipProp(prev => ({ ...prev, visible: false }));
      }}        
    />

    <Group x={0} y={0}>
      <Rect
        visible={tooltipProp.visible}
        width={180}
        height={35}
        x={tooltipProp.x}
        y={tooltipProp.y}
        fill="black"
        stroke="blue"
        strokeWidth={1}
        opacity={1}
      />      
      <Text
        {...tooltipProp}
        fontFamily="Calibri"
        fontSize={14}
        padding={5}
        opacity={1}
        fill={"white"}
      />    
    </Group>
    */}









                    <Group x={tooltip.x} y={tooltip.y}>
                      <Rect
                        width={180}
                        height={35}
                        fill="black"
                        opacity={1}
                        cornerRadius={4}
                      />
                      <Text
                        text={tooltip.text}
                        fill="white"
                        fontSize={14}
                        padding={5}
                      />
                    </Group>
                    
                    </>

                  )}        
                  </Layer>                                                
                </Stage>
              </Row>
            </Col>      
          </div>

          <Container className="row" style={{width:'100vw',margin:'20px'}}>
            <Row className='mt-2'>
              {showerror && (
                <MessageBox show={true} showerror={showerror} errmessage={errmessage}
                  onHide={() => {
                    setShowerror(false)
                  }}
                />
              )}
              {showsuccess && (

                <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
                  onHide={() => {
                  setShowsuccess(false);
                }}
                />
              )}
  
            </Row>            
          </Container>

        </div>

      </div>
      



    </>
  )
}

const ListOfCabinetConfigOptions = (props) => {
  if (!props.cabinetConfigoptions) {
    return 
  }
  const rows = props.cabinetConfigoptions.map((row, index) => {
    if ((row.configid.includes("upperwallMountRangeHoodElement")) || (row.configname.includes("corner")) || ((row.configname.includes("Corner"))) || (row.configid.includes("WallF"))) {
      return null;
    }
    else {
      return (  
        <option key={index} value={row.configid} disabled={row.configid === 'unsel'}>        
          {row.configname}
        </option>
      )
    } 
  })  
  return (      
    <>       
    <option value={-1} disabled selected={Object.keys(props.cabinetConfig).length === 0}>
      {"Select"}
    </option>
    {rows}
    </>
  )
}  


const WallFrontalRect = (props) => {
  return (
    <Rect
      x={wallx}
      y={wally}
      width={props.width}
      height={props.height}
      fill={props.color}
      stroke="black"
      strokeWidth={1}    
      
    />
  );
};

const WrapWallLeftSideRect = (props) => {
  const walls = props.walls;
  const currentWallIndex = props.currentWallIndex;
  const renderLeftRect = currentWallIndex !== 0;
  if (renderLeftRect) { // not first wall
    return ( 
      <WallSideRect 
        side = {'left'}
        currentWallwidth = {inchtopoint(props.currentWallwidth)}
        currentWallHeight = {inchtopoint(props.currentWallHeight)}
        currentWallx = {props.currentWallx}
        currentWally = {props.currentWally}
        color = {props.color}
        wallname = {walls[currentWallIndex-1].wallname.toUpperCase()}
      />
    );
  }
  else {
    return null;
  }
};

const WrapWallRightSideRect = (props) => {
  const walls = props.walls;
  const currentWallIndex = props.currentWallIndex;
  const renderRightRect = currentWallIndex !== walls.length - 1;
  /*
  console.log(currentWallIndex);
  console.log(walls);
  console.log(renderRightRect);
  */

  if (renderRightRect) { // not last wall
    return ( 
      <WallSideRect 
        side = {'right'}
        currentWallwidth = {inchtopoint(props.currentWallwidth)}
        currentWallHeight = {inchtopoint(props.currentWallHeight)}
        currentWallx = {props.currentWallx}
        currentWally = {props.currentWally}
        color = {props.color}
        wallname = {walls[currentWallIndex+1].wallname.toUpperCase()}
      />        
    );
  }
  else {
    return (
      null
    );
  }
};


const WallSideRect = (props) => {  
  var sidewallx;
  if (props.side === 'right') {
    sidewallx = props.currentWallwidth + props.currentWallx;
  }
  else {
    sidewallx = wallx - sidewallWidth;
  }
  var wallnamex = sidewallx+(sidewallWidth/2)-5;
  console.log(sidewallx);
  return (
    <Layer width={sidewallWidth}>
      <Rect
        x={sidewallx}
        y={props.currentWally}
        width={sidewallWidth}
        height={props.currentWallHeight}
        fill={sidewallColor}
        stroke="black"
        strokeWidth={1}      
      />
      <Text 
        rotation={-90} 
        text={props.wallname} 
        align="center" 
        width={props.currentWallHeight} 
        y={props.currentWally+props.currentWallHeight} 
        x={wallnamex} 
        height={1}
      /> 
    </Layer>
  );
};


export default NewKitchenFastQuote;